import React, { Component } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    ButtonGroup,
    Form,
    DropdownButton,
    Dropdown,
    Tab,
    Tabs,
    Nav
} from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
    Search,
    // CSVExport,
} from "react-bootstrap-table2-toolkit";
import Modal from "react-bootstrap/Modal";
import Collapse from "react-bootstrap/Collapse";
import Select from 'react-select';
import moment from "moment";
import 'moment/locale/id';
import axios from 'axios';
import { uAPIlocal } from '../../lib/config';
import { withRouter, Redirect } from 'react-router-dom';
import Swal from "sweetalert2";
import { ComboBox } from 'rc-easyui';
import TextPost from './TextPost';
import Dropzone from 'react-dropzone';
import ButtonPrintLab from './ButtonPrintLab';
import ButtonPrintResep from './ButtonPrintResep';
import ButtonPrintSuratSakit from './ButtonPrintSuratSakit';
import { EditorState, convertToRaw, convertFromRaw, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { stateToHTML } from "draft-js-export-html";
import { TimePicker, Checkbox, Flex, Radio } from 'antd';
import painscale_0 from '../../../assets/painscale_0.png';
import painscale_1 from '../../../assets/painscale_1.png';
import painscale_2 from '../../../assets/painscale_2.png';
import painscale_3 from '../../../assets/painscale_3.png';
import painscale_4 from '../../../assets/painscale_4.png';
import painscale_5 from '../../../assets/painscale_5.png';
import painscale_6 from '../../../assets/painscale_6.png';
import painscale_7 from '../../../assets/painscale_7.png';
import painscale_8 from '../../../assets/painscale_8.png';
import painscale_9 from '../../../assets/painscale_9.png';
import painscale_10 from '../../../assets/painscale_10.png';
import painscale_info from '../../../assets/painscale_info.png';
import Badge from 'react-bootstrap/Badge';
import _editDoc from "../../../assets/font-awesome/white/png/128/pencil-square.png";
import _editDocB from "../../../assets/font-awesome/black/png/128/pencil-square.png";
import plus from "../../../assets/font-awesome/white/png/128/plus.png";
import _thumbs from "../../../assets/font-awesome/white/png/128/thumbs-up.png";
import _infoDoc from "../../../assets/font-awesome/white/png/128/info-circle.png";
import _pdf from "../../../assets/font-awesome/black/png/128/file-pdf-o.png";
import _clock from "../../../assets/font-awesome/white/png/128/clock-o.png";
import _pencil from "../../../assets/font-awesome/white/png/128/pencil-square.png";
import Cookies from 'js-cookie';

let source = axios.CancelToken.source();
axios.defaults.withCredentials = true;
moment.locale('id');
const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
});

const numberFormat = (value) =>
    new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);




class People extends Component {
    constructor(props) {
        super(props);
        this.modalRef = React.createRef();
        this.state = {
            redirctTo: false,
            selectedYear: '2023',
            tableInbox: true,
            datas: [],
            _totalPage: 0,
            showModal: false,
            dataDetail: [],
            selectedRows: null,
            isSelected: false,

            // nextpage
            redirect: false,
            pathname: "",
            idSelected: "",
            prevState: "",
            prevPage: "",
            goTo: "",
            action: "false",


            // props
            _id: this.props.location.state ? this.props.location.state.id : null,
            _conc_id: this.props.location.state ? this.props.location.state.conc_id : null,
            _prevPage: this.props.location.state ? this.props.location.state.prevPage : null,
            _prevState: this.props.location.state ? this.props.location.state.prevState : null,

            searchValue: this.props.location.state ? this.props.location.state.id : null,
            searchWord: '',

            peserta_selected: [],
            filter_peserta: false,
            detailClicked: false,
            redirectDetail: [],
            isSearch: false,
            dataSearch: [],

            clr_child: true,
            modalForm: false,
            modalFormResult: false,
            modalFormLab: false,

            // form peserta
            peserta_namaPasien: "",
            peserta_NOMR: "",
            peserta_NOREG: "",
            peserta_dateReg: new Date().toISOString().slice(0, 10),
            // peserta_dob: new Date().toISOString().slice(0, 10),
            peserta_jenisKelamin: "Laki - Laki",
            peserta_tempatLahir: "",
            peserta_alamat: "",
            peserta_tglLayanan: new Date().toISOString().slice(0, 10),
            peserta_nasabah: "ASURANSI",
            peserta_noBuktiLayanan: "",
            peserta_dpjp: "",
            peserta_prioritas: "",
            peserta_tanggalLahir: new Date().toISOString().slice(0, 10),
            peserta_informasi: "",
            peserta_antrian: "",
            peserta_petugas: "",
            peserta_petugasName: "",
            peserta_email: "",
            peserta_noTelp: "",
            peserta_dateReturn: new Date().toISOString().slice(0, 10),

            // form pembayaran
            peserta_idPembayaran: "",
            peserta_metodePembayaran: "CASH",
            peserta_tglPembayaran: new Date().toISOString().slice(0, 10),
            peserta_statusPembayaran: "BELUM LUNAS",
            peserta_ketBiayaKonsul: "",
            peserta_pembayaranKonsultasi: "0",
            peserta_pembayaranDiskon: "0",
            peserta_alasanDiskon: "",
            peserta_tipePasien: "0",
            peserta_kontrolUlang: "0",
            peserta_suratSakitHari: 0,

            // form exam
            peserta_dateExam: new Date().toISOString().slice(0, 10),
            peserta_NOREG: "",
            peserta_NAMA_PASIEN: "",
            // peserta_diagnosaPrimary: "",
            // peserta_diagnosaSecondary: "",
            peserta_S: "",
            peserta_O_KESADARAN: "",
            // peserta_O_TEKANAN: "",
            sistolik: "",
            diastolik: "",
            peserta_O_PERNAPASAN: "",
            peserta_O_NADI: "",
            peserta_O_BERAT: "",
            peserta_O_SUHU: "",
            peserta_O_TINGGI: "",
            peserta_O_SATURASI: "",
            peserta_O_SKALA_NYERI: "",
            peserta_O: "",
            peserta_A: "",
            peserta_P: "",
            peserta_catatan: "",
            peserta_dokterInput: "",
            peserta_dokterInputName: "",

            // from reg
            peserta_statusSelesai: "SELESAI",

            // date_result: new Date().toISOString().slice(0, 10),
            date_result: moment().format('YYYY-MM-DDTHH:mm'),
            lab_result_file: "",
            lab_result_no: "",

            tabkey: 1,
            _delSwalPatient: false,
            _editFormActive: false,
            _resultFormActive: false,
            updateBtnV2: false,

            loading: true,
            historyExamID: [],
            historyExam: [],
            selectedFile: null,
            files: [],
            showInfo: false,
            formPerawat: false,

            peserta_filter:
            {
                label: Cookies.get('biomedika-level') != 4 ? "Exam" : "Registrasi",
                value: Cookies.get('biomedika-level') != 4 ? "exam" : "registrasi"
            },
            // peserta_filter: "exam",
            _goPlayAudio: false,
            peserta_catatanPemeriksaanPenunjang: "",
            peserta_catatanResep: "",
            peserta_O_CONDITIONAL: "",
            examSelected: [],
            editorState: EditorState.createEmpty(),
            user_selected: [],
            resep: [{ r: "", s: "" }],
            O_CONDITIONAL: [{ v1: "", v2: "" }],
            peserta_BMI: "",

            peserta_pekerjaan: "",
            peserta_riwayatKeluhanUtama: "",
            peserta_riwayatPenyakitKeluarga: "",
            peserta_riwayatPenyakitDahulu: "",
            peserta_riwayatAlergiObat: "",

            getIDdokter: '',

        };
        this.getExam = this.getExam.bind(this);
        this.handleRowsClick = this.handleRowsClick.bind(this)
        this.fetchDataDetail = this.fetchDataDetail.bind(this)
        // this.modalRef = this.modalRef.bind(this)
        this.handleModalRedirect = this.handleModalRedirect.bind(this);
        this.handleSelect = this.handleSelect.bind(this);

        this.onChange = this.onChange.bind(this);
        this.onChangeStatusSelesai = this.onChangeStatusSelesai.bind(this);
        // this.onFileChange = this.onFileChange.bind(this);
        this.updateSubmit_v2 = this.updateSubmit_v2.bind(this);

        this.addClick = this.addClick.bind(this);
        this.addClick2 = this.addClick2.bind(this);
        this.autoLogout = this.autoLogout.bind(this);

        source = axios.CancelToken.source();
        this.onDrop = (files) => {
            this.setState({ files })
        };


    }



    async componentDidMount() {

        // if (Cookies.get('biomedika-level') != 4) {
        //     this.setState({
        //         peserta_filter: {
        //             label: "Exam",
        //             value: "exam"
        //         }
        //     })
        // }


        this.playInterval();

        console.log("INI STATE PROPS", this.props.location.state)

        if (this.state._id != null) {

            if (this.state._prevPage == "" && this.state._prevState == "") { }

        } else {
            // this.setState({ tableInbox: false })
            if (this.state.peserta_filter?.value == "exam") {
                setTimeout(() => {
                    this.getExam();
                    // this.setState({
                    //     tableInbox: true
                    // })
                }, 2000);
            } else {
                setTimeout(() => {
                    this.getPatient();
                    // this.setState({
                    //     tableInbox: true
                    // })
                }, 2000);
            }


            this.getNOREG();
            this.getDokter();
            this.getBranch();
        }

        if (Cookies.get('biomedika-level') == 4) {
            this.setState({ formPerawat: true })
        }

        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        formData.append('id_user', Cookies.get('biomedika-csrf'));
        formData.append('name', localStorage.getItem("name"));
        formData.append('message', "Klinik - Akses Exam");


        await axios.post(uAPIlocal + '/api/v1/log', formData, config)
            .then(response => {
                console.log(response)
                if (response.data.status === 406) {
                    console.log(response)

                } else {
                    console.log(response)
                }

            })
            .catch(function (error) {
                console.log(error);
            });



    }
    componentDidUpdate(prevProps, prevState) {
        console.log(prevState, "prev state")
        if (prevState.selectedRows !== this.state.selectedRows) {
            // console.log(this.state.selectedRows, "selectedRows")
            // console.log(prevState, "prev")
            var element = document.getElementById(`border-custom-${this.state.selectedRows}`)
            if (element) {
                element.classList.add('row-custom-selected')
                var element2 = document.getElementById(`border-custom-${prevState.selectedRows}`)
                if (element2) {
                    element2.classList.remove('row-custom-selected')
                    // console.log(this.state.showModal, "showModal")
                }


            }

            console.log(element, 'element')

        }
    }
    componentWillUnmount() {
        window.location.reload();
        this.stopInterval();
        document.removeEventListener("mousedown", this.handleClose)
        if (source) {
            source.cancel("Landing Component got unmounted");
        }
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            editorState,
        });
        // console.log(editorState.getCurrentContent().getPlainText());
        // this.setState({
        //     convertedContent: convertToRaw(
        //         this.state.editorState.getCurrentContent()
        //     ),
        // });
        // console.log(stateToHTML(this.state.editorState.getCurrentContent()));
    };

    // convertToRaw = () => {
    //     this.setState({
    //         convertedContent: convertToRaw(
    //             this.state.editorState.getCurrentContent()
    //         ),
    //     });
    // };


    playInterval() {
        this.interval = setInterval(() => {
            console.log("interval load")
            if (this.state.peserta_filter?.value == "exam") {
                this.getExam();
            } else {
                this.getPatient();
            }
            this.getNOREG();
        }, 30000);
    }

    stopInterval() {
        clearInterval(this.interval);
    }

    addClick() {
        this.setState(prevState => ({
            resep: [...prevState.resep, { r: "", s: "" }]
        }))
    }

    addClick2() {
        this.setState(prevState => ({
            O_CONDITIONAL: [...prevState.O_CONDITIONAL, { v1: "", v2: "" }]
        }))
    }



    createUI() {
        return this.state.resep.map((el, i) => (
            // <div key={i}>
            //     <input placeholder="" name="r" value={el.r || ''} onChange={this.handleChange.bind(this, i)} />
            //     <input placeholder="" name="s" value={el.s || ''} onChange={this.handleChange.bind(this, i)} />
            //     <input type='button' value='remove' onClick={this.removeClick.bind(this, i)} />
            // </div>

            <div className="col-md-12">
                <div className="form-group">

                    <table style={{ width: '100%' }}>
                        <tr>
                            <td><label className="form-label">Obat {i + 1}</label></td>
                            <td style={{ float: 'right', display: i == 0 ? 'none' : null }}>
                                {/* <button className="btn btn-danger btn-sm" onClick={this.removeClick.bind(this, i)}>
                                    <i className="fa fa-trash" />
                                </button> */}
                            </td>
                        </tr>
                    </table>


                    <div className="input-group">
                        <div className="input-group-append" >
                            <span className="input-group-text" style={{ backgroundColor: '#0ba360', color: '#fff', width: '41px' }}> R/ </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Glucophage tab 500mg No. XXX"
                            name="r"
                            value={el.r || ''}
                            onChange={this.handleChange.bind(this, i)}
                        />
                    </div>
                    <div className="input-group">
                        <div className="input-group-append" >
                            <span className="input-group-text" style={{ backgroundColor: '#0ba360', color: '#fff', width: '41px' }}> S </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="3 dd 1 tab pc"
                            name="s"
                            value={el.s || ''}
                            onChange={this.handleChange.bind(this, i)}
                        />
                    </div>
                    {/* <input type='button' value='remove' onClick={this.removeClick.bind(this, i)} /> */}


                </div>
            </div>

        ))
    }

    createUI2() {
        return this.state.O_CONDITIONAL.map((el, i) => (


            <div className="col-md-12">
                <div className="form-group">

                    <table style={{ width: '100%' }}>
                        <tr>
                            <td><label className="form-label">O (CONDITIONAL ) {i + 1}</label></td>
                        </tr>

                        <tr>
                            <td>
                                <div className="input-group">
                                    <div className="input-group-append" >
                                        <span className="input-group-text" style={{ backgroundColor: '#0ba360', color: '#fff', width: '41px', fontSize: 12 }}> Var </span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Variabel"
                                        name="v1"
                                        value={el.v1 || ''}
                                        onChange={this.handleChange2.bind(this, i)}
                                    />
                                </div>
                            </td>
                            <td>
                                <div className="input-group">
                                    <div className="input-group-append" >
                                        <span className="input-group-text" style={{ backgroundColor: '#0ba360', color: '#fff', width: '41px', fontSize: 12 }}> Val </span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Value"
                                        name="v2"
                                        value={el.v2 || ''}
                                        onChange={this.handleChange2.bind(this, i)}
                                    />
                                </div>
                            </td>
                        </tr>


                    </table>




                </div>
            </div>

        ))
    }

    handleChange(i, e) {
        const { name, value } = e.target;
        let resep = [...this.state.resep];
        resep[i] = { ...resep[i], [name]: value };
        this.setState({ resep });
    }

    handleChange2(i, e) {
        const { name, value } = e.target;
        let O_CONDITIONAL = [...this.state.O_CONDITIONAL];
        O_CONDITIONAL[i] = { ...O_CONDITIONAL[i], [name]: value };
        this.setState({ O_CONDITIONAL });
    }

    removeClick(i) {
        let resep = [...this.state.resep];
        resep.splice(i, 1);
        this.setState({ resep });
    }

    removeClick2(i) {
        let O_CONDITIONAL = [...this.state.O_CONDITIONAL];
        O_CONDITIONAL.splice(i, 1);
        this.setState({ O_CONDITIONAL });
    }

    fetchDataDetail(NOMR) {

        const matchedPatient = this.state.datas.filter(i => i.NOMR === NOMR)
        console.log("ini yang match", matchedPatient);

        var uniqueArray = matchedPatient.reduce(function (a, d) {
            if (a.indexOf(d.NOREG) === -1) {
                a.push(d.NOREG);
            }
            return a;
        }, []);

        this.setState({ historyExamID: uniqueArray })

        console.log("ini yang unique", uniqueArray);

        uniqueArray.map(item => {

            // alert(item);
            this.setState({ historyExam: [] })
            let f = new FormData();
            f.append('NOREG', item);
            axios({
                method: "post",
                url: uAPIlocal + "/api/v1/detail_patient",
                data: f,
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then((response) => {

                    // console.log("ini hasil dari exam ->" + item, response.data.results);

                    this.setState({ historyExam: [...this.state.historyExam, response.data.results] })

                    console.log("ini hasil dari history exam ->", this.state.historyExam);

                })
                .catch((e) => {
                    console.error(e);
                });



        })

        if (!this.state._goDownload) {
            this.setState({ showModal: true })
            this.setState({ isSelected: true })
            this.setState({ detailClicked: true })
            this.setState({ clr_child: false })
        }



    }


    async getDokter() {

        await axios.post(uAPIlocal + `/api/v1/dokter`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata dokter", response.results);
                const _datas = response.results.sort(function (a, b) {
                    return a.NAMA_DOKTER < b.NAMA_DOKTER;
                });

                let _dokter = []
                if (_datas.length > 0) {
                    _datas.forEach(element => {
                        // if (element.level == 2) {
                        _dokter.push({
                            value: element.ID_DOKTER,
                            label: element.NAMA_DOKTER,
                        })
                        // }
                    });
                }
                this.setState({ optDokter: _dokter, chooseDokter: _dokter[0] }, () =>
                    console.log("ok")
                )


            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async getBranch() {
        await axios.post(uAPIlocal + `/api/v1/branch`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata konsul", response.results);
                const _datas = response.results.sort(function (a, b) {
                    return a.branch_name > b.branch_name;
                });


                let branch = []
                if (_datas.length > 0) {
                    _datas.forEach(element => {
                        if (element.branch_code) {
                            branch.push({
                                value: element.branch_code,
                                label: element.branch_name,
                            })
                        }
                    });
                }

                this.setState({ optBranch: branch }, () =>
                    console.log("ok")
                )

                let indexBranch = this.state.optBranch.findIndex(function (item, i) {
                    return item.value === localStorage.getItem("branch")
                });

                this.setState({ chooseBranch: this.state.optBranch[indexBranch] })

            })
            .catch(function (error) {
                console.log(error);
            });
    }



    handleModalRedirect(id) {
        var id_company = localStorage.getItem("Company_ID");

        if (this.state._prevPage == "department" && this.state._prevState == "department_peserta") {
            this.setState({
                redirect: true,
                pathname: "/admin/departemen",
                idSelected: this.state._id,
                prevState: "back",
                prevPage: "people",
                goTo: this.state._prevState,
            });
        }

        if (id) {
            this.fetchDataDetail(id, id_company)
        }
    }

    handleClose = event => {
        if (this.modalRef && !this.modalRef.textContent) {
            this.setState({ showModal: false })
            this.setState({ isSelected: false })
            this.setState({ detailClicked: false })
            var element = document.getElementById(`border-custom-${this.state.selectedRows}`)
            if (element) {
                element.classList.remove(`row-custom-selected`)
            }
        }

    }



    async getExam() {
        // var id_company = localStorage.getItem("Company_ID");
        var year = this.state.selectedYear;
        console.log(this.state.searchValue, "search value")

        var _dpjp = "";

        if (localStorage.getItem("id_dokter")) {
            _dpjp = localStorage.getItem("id_dokter");
        }

        let _url = "";

        // await axios.post(uAPIlocal + `/api/v1/exam/${localStorage.getItem("id_dokter")}`)

        if (Cookies.get('biomedika-level') == 2) {
            _url = uAPIlocal + `/api/v1/exam/${localStorage.getItem("id_dokter")}?lvl=${Cookies.get('biomedika-level')}`;
        } else if (Cookies.get('biomedika-level') == 4) {
            _url = uAPIlocal + `/api/v1/exam/${localStorage.getItem("branch")}?lvl=${Cookies.get('biomedika-level')}`;
        } else if (Cookies.get('biomedika-level') == 3) {
            _url = uAPIlocal + `/api/v1/exam/${"ALL"}?branch=${'ALL'}?lvl=${Cookies.get('biomedika-level')}`;
        } else { }


        await axios.post(_url)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(async response => {
                console.log("mydata exam", response.results);
                if (response.results.length == 0) {
                    this.setState({ tableInbox: true });
                }

                // const matchedPatient = _datas.filter(i => this.state.peserta_selected.indexOf(i.Patient_id) >= 0)

                // if (this.state.filter_peserta == true) {
                //     this.setState({ datas: matchedPatient })
                // } else {
                //     this.setState({ datas: _datas })
                // }

                let mydata = response.results;

                if (mydata.length > 0) {
                    const setData = (event) => {
                        const _datas = mydata.sort(function (a, b) {
                            return b.ID_EXAM - a.ID_EXAM;
                        });
                        this.setState({ datas: _datas }, () => setTimeout(() => { this.setState({ tableInbox: true }) }, 1000));
                    };

                    await response.results.map(async function (item, index) {
                        let getDetail = await axios.post(uAPIlocal + `/api/v1/get-file/${item.ID_EXAM}`, {
                            cancelToken: source.token
                        })

                        console.log("mydata fileszzz", getDetail.data.results);

                        if (getDetail.data.results.length > 0) {
                            console.log("mydata filesaaaa", getDetail.data.results[0].ID_EXAM)
                            let keyIndex = response.results.findIndex((x) => x.ID_EXAM === getDetail.data.results[0].ID_EXAM);
                            console.log("mydata filesxxx", index);
                            if (index != -1) {
                                var newKey = "FILES";
                                var newVal = getDetail.data.results;
                                mydata[keyIndex][newKey] = newVal;
                            } else {
                                // var newKey = "FILES";
                                // var newVal = [];
                                // mydata[index][newKey] = newVal;
                            }
                        }

                        if (response.results.length == (index + 1)) {
                            setTimeout(() => {
                                setData();
                            }, 1000);

                        }

                    });
                } else {
                    this.setState({ datas: [] })
                }





                if (Number.isInteger(response.results.length / 10) == true) {
                    var x = (response.results.length / 10);
                    this.setState({
                        _totalPage: x
                    })
                } else {
                    var x = Math.round(this.state.datas.length / 10) < (this.state.datas.length / 10) ? Math.round(this.state.datas.length / 10) + 1 : Math.round(this.state.datas.length / 10);
                    this.setState({
                        _totalPage: x
                    })

                }


            })
            .catch((e) => {
                console.log(e);
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
                this.autoLogout();
            });
    }


    async getPatient() {

        var _dpjp = "";

        if (localStorage.getItem("id_dokter")) {
            _dpjp = localStorage.getItem("id_dokter");
        }

        let _url = "";

        if (Cookies.get('biomedika-level') == 2) {
            _url = uAPIlocal + `/api/v1/patient/${this.state.peserta_filter?.value}?dpjp=${_dpjp}`;
        } else if (Cookies.get('biomedika-level') == 4) {
            _url = uAPIlocal + `/api/v1/patient/${this.state.peserta_filter?.value}?branch=${localStorage.getItem("branch")}&lvl=${4}&page=exam`;
        } else if (Cookies.get('biomedika-level') == 3) {
            _url = uAPIlocal + `/api/v1/patient/${this.state.peserta_filter?.value}?branch=${'ALL'}`;
        } else { }

        await axios.post(_url)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata pasien", response.results);
                if (response.results.length == 0) {
                    this.setState({ tableInbox: true });
                }
                const _datas = response.results.sort(function (a, b) {
                    return a.ID_REGISTRASI < b.ID_REGISTRASI;
                });

                let peoples = []
                _datas.forEach(item => {
                    if (item.return_request == 2) {
                        // peoples.push(item)
                    } else if (item.return_request == 0 && item.STATUS == "") {
                        peoples.push(item)
                    } else { }
                });

                console.log("data perawat", peoples);

                if (Cookies.get('biomedika-level') == 4) {
                    this.setState({ datas: peoples }, () => setTimeout(() => { this.setState({ tableInbox: true }) }, 1000))
                } else {
                    this.setState({ datas: _datas }, () => setTimeout(() => { this.setState({ tableInbox: true }) }, 1000))
                }

                if (Number.isInteger(response.results.length / 10) == true) {
                    var x = (response.results.length / 10);
                    this.setState({
                        _totalPage: x
                    })
                } else {
                    var x = Math.round(this.state.datas.length / 10) < (this.state.datas.length / 10) ? Math.round(this.state.datas.length / 10) + 1 : Math.round(this.state.datas.length / 10);
                    this.setState({
                        _totalPage: x
                    })

                }

                // this.getAllPatientForNOMR();


            })
            .catch((e) => {
                console.log(e);
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
                this.autoLogout();
            });
    }

    autoLogout = () => {
        this.setState({ redirctTo: true });
    }


    async getNOREG() {
        // var id_company = localStorage.getItem("Company_ID");
        var year = this.state.selectedYear;
        let e = 'exam';
        console.log(this.state.searchValue, "search value")
        await axios.post(uAPIlocal + `/api/v1/patient/${e}`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata", response.results);
                const _datas = response.results.sort(function (a, b) {
                    return a.ID_REGISTRASI > b.ID_REGISTRASI;
                });


                let peoples = []
                peoples.push({
                    value: "",
                    label: "--- Pilih Peserta ---",
                });
                if (_datas.length > 0) {
                    _datas.forEach(element => {
                        if (element.ID_REGISTRASI) {
                            peoples.push({
                                value: element.NOREG,
                                label: element.NOREG + " - " + element.NAMA_PASIEN,
                                name: element.NAMA_PASIEN,
                            })
                        }
                    });
                }
                this.setState({ optPeserta: peoples, choosePeserta: peoples[0] }, () =>
                    console.log("ok")
                )


            })
            .catch(function (error) {
                console.log(error);
            });
    }




    imgFormatter(cell, row) {
        return (
            <div className="rounded-corners-users"></div>
        );
    }

    handleRowsClick(cell, row, rowIndex) {
        console.log(this.state.selectedRows, "handle function")
        return (
            <div className={`border-custom-${rowIndex}`} id={`border-custom-${rowIndex}`}>
                {cell}
            </div>
        )
    }
    // emptyValueFormatter(cell, row, rowIndex) {
    //     if (cell === null || cell === undefined || cell === "") {
    //         return "";
    //     }
    //     return cell;
    // };
    // btnFormatter = (cell, row) => {
    //     const onclick = (event) => {
    //         // console.log("clicked on row ", row);
    //         this.handleShowModalSentTo();
    //     };
    //     return (
    //         <Button
    //             className="button-block btn-tropical-rain-forest"
    //             onClick={onclick}
    //             style={{ zIndex: 99 }}
    //         >
    //             1/1
    //         </Button>
    //     );
    // };
    // redValueFormatter(cell, row, rowIndex) {
    //     console.log(cell, "ini cell")
    //     console.log(row.F2023, "ini row")
    //     console.log(rowIndex, "ini rowindex")

    //     if (row.F2023 === "High") {
    //         return (<p style={{ color: 'red' }}>{cell}</p>);
    //     }
    //     if (row.F2023 === "Low") {
    //         return (<p style={{ color: 'red' }}>{cell}</p>);
    //     }
    //     return cell;
    // };


    handleLastPage = ({
        page,
        onPageChange
    }) => () => {
        onPageChange(this.state._totalPage);
    }


    handleNextPage = ({
        page,
        onPageChange
    }) => () => {
        onPageChange(page + 1);
    }

    handlePrevPage = ({
        page,
        onPageChange
    }) => () => {
        onPageChange(page - 1);
    }

    // handleSizePerPage = ({
    //     page,
    //     onSizePerPageChange
    // }, newSizePerPage) => {
    //     onSizePerPageChange(newSizePerPage, page);
    // }



    handleCloseModalDetail = () => () => {

        this.playInterval();

        this.setState({ showModal: false })
        this.setState({ isSelected: false })
        this.setState({ detailClicked: false })
        this.setState({ clr_child: true })
        this.setState({ showInfo: false })

        // var element = document.getElementById(`border-custom-${this.state.selectedRows}`)
        // if (element) {
        // element.classList.remove(`row-custom-selected`)
        // }

        if (this.state._prevPage == "top10" && this.state._prevState == "top10_peserta") {
            this.setState({ action: true })
        }

        if (this.state._prevPage == "department" && this.state._prevState == "department_peserta") {
            this.setState({ action: true })
        }
    }


    handleCloseModalForm() {
        this.setState({ modalForm: false });
        this.resetForm();
    }


    handleCloseModalFormResult() {
        this.setState({ modalFormResult: false });
        this.resetForm();
    }

    handleCloseModalFormLab() {
        this.setState({ modalFormLab: false });
        this.resetForm();
    }

    openModalAddForm() {
        this.setState({ modalForm: true, tabkey: 1 });
        this.stopInterval();
    }


    resetForm() {
        this.playInterval();
        this.setState({
            peserta_dateExam: new Date().toISOString().slice(0, 10),
            // peserta_diagnosaPrimary: "",
            // peserta_diagnosaSecondary: "",
            peserta_S: "",
            peserta_O_KESADARAN: "",
            // peserta_O_TEKANAN: "",
            sistolik: "",
            diastolik: "",
            peserta_O_PERNAPASAN: "",
            peserta_O_NADI: "",
            peserta_O_BERAT: "",
            peserta_O_SUHU: "",
            peserta_O_TINGGI: "",
            peserta_O_SATURASI: "",
            peserta_O_SKALA_NYERI: "",
            peserta_O: "",
            peserta_A: "",
            peserta_P: "",
            peserta_catatan: "",
            peserta_dokterInput: "",
            peserta_dokterInputName: "",
            tabkey: 1,
            _delSwalPatient: false,
            _editFormActive: false,
            _resultFormActive: false,
            updateBtnV2: false,
            detailClicked: false,
            showModal: false,
            choosePeserta: this.state.optPeserta[0],
            showInfo: false,
            files: [],
            peserta_statusSelesai: "SELESAI",
            editorState: EditorState.createEmpty(),
            user_selected: [],
            peserta_pembayaranKonsultasi: "0",
            peserta_pembayaranDiskon: "0",
            peserta_alasanDiskon: "",
            peserta_tipePasien: "0",
            peserta_kontrolUlang: "0",
            peserta_suratSakitHari: 0,
            _goPlayAudio: false,
            clr_child: true,
            modalForm: false,
            modalFormResult: false,
            modalFormLab: false,
            resep: [{ r: "", s: "" }],
            peserta_O_CONDITIONAL: "",
            O_CONDITIONAL: [{ v1: "", v2: "" }],
            peserta_BMI: "",
            peserta_pekerjaan: "",
            peserta_riwayatKeluhanUtama: "",
            peserta_riwayatPenyakitKeluarga: "",
            peserta_riwayatPenyakitDahulu: "",
            peserta_riwayatAlergiObat: "",

            getIDdokter: '',
        })
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onChangeStatusSelesai(e) {
        // alert(e.target.value)
        this.setState({
            peserta_statusSelesai: e.target.value
        })
    }


    // onFileChange(e) {
    //     this.setState({ selectedFile: e.target.files[0] });
    // }

    getUserBranch(l, b) {
        axios.post(uAPIlocal + `/api/v1/user/${"getuserbranch"}?branch=${b}&lvl=${l}`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata admin branch", response.results);
                let datas = response.results;
                // this.setState({ user_selected: datas })
                datas.map((item, index) => {
                    this.setState({
                        user_selected: [...this.state.user_selected, item]
                    }, console.log("user_selected", this.state.user_selected))
                })


            })
            .catch(function (error) {
                console.log(error);
            });
    }


    bmiCalc(h, w) {
        let height = h;
        let weight = w;
        let result = '';
        if (height === "" || isNaN(height)) {
            result = "Provide a valid Height!";
        } else if (weight === "" || isNaN(weight)) {
            result = "Provide a valid Weight!";
        }
        else {
            let bmi = (weight / ((height * height) / 10000)).toFixed(2);
            if (bmi < 18.6) {
                result = `${bmi} (Under Weight)`;
            } else if (bmi >= 18.6 && bmi < 24.9) {
                result = `${bmi} (Normal)`;
            } else {
                result = `${bmi} (Over Weight)`;
            }
        }
        return result;
    }

    getDateRange = (firstDate, lastDate) => {
        if (moment(firstDate, 'YYYY-MM-DD').isSame(moment(lastDate, 'YYYY-MM-DD'), 'day'))
            return [lastDate];
        let date = firstDate;
        const dates = [date];
        do {
            date = moment(date).add(1, 'day');
            dates.push(date.format('YYYY-MM-DD'));
        } while (moment(date).isBefore(lastDate));
        return dates.length;
    };


    save_v2() {

        let _hours = new Date().toLocaleString("id-ID", {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });

        // buat selected JSON yang membandingkan antara json dan inputan, jika ada perubahan maka kirim ke log dengan mapping
        // lalu lempar ke fungsi lain buat insert log, log punya id exam, berarti id exam di 

        // ini save

        let _InputExamHistory = [];

        if (this.state.formPerawat) {
            if (this.state.peserta_O_KESADARAN != "") {
                _InputExamHistory.push({
                    value: "Kesadaran",
                    label: this.state.peserta_O_KESADARAN,
                })
            }

            if (this.state.sistolik != "" && this.state.diastolik != "") {
                _InputExamHistory.push({
                    value: "Tekanan",
                    label: this.state.sistolik + "/" + this.state.diastolik + " mmHg",
                })
            }

            if (this.state.peserta_O_PERNAPASAN != "") {
                _InputExamHistory.push({
                    value: "Pernapasan",
                    label: this.state.peserta_O_PERNAPASAN + " x /menit",
                })
            }

            if (this.state.peserta_O_NADI != "") {
                _InputExamHistory.push({
                    value: "Nadi",
                    label: this.state.peserta_O_NADI + " denyut /menit",
                })
            }

            if (this.state.peserta_O_BERAT != "") {
                _InputExamHistory.push({
                    value: "Berat",
                    label: this.state.peserta_O_BERAT + " kg",
                })
            }

            if (this.state.peserta_O_SUHU != "") {
                _InputExamHistory.push({
                    value: "Suhu",
                    label: this.state.peserta_O_SUHU + " ℃",
                })
            }

            if (this.state.peserta_O_TINGGI != "") {
                _InputExamHistory.push({
                    value: "Tinggi",
                    label: this.state.peserta_O_TINGGI + " cm",
                })
            }

            if (this.state.peserta_O_SATURASI != "") {
                _InputExamHistory.push({
                    value: "Saturasi",
                    label: this.state.peserta_O_SATURASI + " %",
                })
            }

            if (this.state.peserta_O_SKALA_NYERI != "") {
                _InputExamHistory.push({
                    value: "Skala Nyeri",
                    label: this.state.peserta_O_SKALA_NYERI,
                })
            }


        } else { }


        let BMI = this.bmiCalc(this.state.peserta_O_TINGGI, this.state.peserta_O_BERAT);


        let f = new FormData();

        if (this.state.examSelected.REG_STATUS == "konsultasi") {
            f.append('mode', 'konsultasi');
        } else {
            f.append('mode', 'klinik');
        }

        if (this.state.formPerawat) {
            f.append('NOREG', this.state.choosePeserta?.value);
            f.append('nama_peserta', this.state.choosePeserta?.name);
            f.append('dateExam', moment(this.state.peserta_dateExam + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('YYYY-MM-DD hh:mm:ss'));
            f.append('S', "");
            f.append('O_KESADARAN', this.state.peserta_O_KESADARAN);
            // f.append('O_TEKANAN', this.state.peserta_O_TEKANAN);
            f.append('SISTOLIK', this.state.sistolik);
            f.append('DIASTOLIK', this.state.diastolik);
            f.append('O_PERNAPASAN', this.state.peserta_O_PERNAPASAN);
            f.append('O_NADI', this.state.peserta_O_NADI);
            f.append('O_BERAT', this.state.peserta_O_BERAT);
            f.append('O_SUHU', this.state.peserta_O_SUHU);
            f.append('O_TINGGI', this.state.peserta_O_TINGGI);
            f.append('O_SATURASI', this.state.peserta_O_SATURASI);
            f.append('O_SKALA_NYERI', this.state.peserta_O_SKALA_NYERI);
            f.append('O', "");
            f.append('A', "");
            f.append('P', "");
            f.append('CATATAN', "")
            // f.append('dokterInput', this.state.chooseDokter?.value);
            f.append('dokterInput', this.state.getIDdokter);
            f.append('statusSelesai', "Selesai Diperiksa Perawat");
            f.append('CATATANLAB', "");
            f.append('lvl', 4);
            f.append('id_user', Cookies.get('biomedika-csrf'));
            f.append('name', localStorage.getItem("name"));
            f.append('InputExamHistory', JSON.stringify(_InputExamHistory));
            f.append('BMI', BMI);
        } else {

            // superuser 
            f.append('NOREG', this.state.choosePeserta?.value);
            f.append('dateExam', moment(this.state.peserta_dateExam + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('YYYY-MM-DD hh:mm:ss'));
            f.append('S', this.state.peserta_S);
            f.append('O_KESADARAN', this.state.peserta_O_KESADARAN);
            // f.append('O_TEKANAN', this.state.peserta_O_TEKANAN);
            f.append('SISTOLIK', this.state.sistolik);
            f.append('DIASTOLIK', this.state.diastolik);
            f.append('O_PERNAPASAN', this.state.peserta_O_PERNAPASAN);
            f.append('O_NADI', this.state.peserta_O_NADI);
            f.append('O_BERAT', this.state.peserta_O_BERAT);
            f.append('O_SUHU', this.state.peserta_O_SUHU);
            f.append('O_TINGGI', this.state.peserta_O_TINGGI);
            f.append('O_SATURASI', this.state.peserta_O_SATURASI);
            f.append('O_SKALA_NYERI', this.state.peserta_O_SKALA_NYERI);
            f.append('O', this.state.peserta_O);
            f.append('A', this.state.peserta_A);
            f.append('P', this.state.peserta_P);
            f.append('CATATAN', this.state.peserta_catatan);
            f.append('dokterInput', Cookies.get('biomedika-csrf'));
            f.append('statusSelesai', this.state.peserta_statusSelesai);
            f.append('CATATANLAB', this.state.peserta_catatanPemeriksaanPenunjang);
            // f.append('CATATANRESEP', this.state.peserta_catatanResep);
            // f.append("CATATANRESEP", stateToHTML(this.state.editorState.getCurrentContent()))

            f.append('CATATANRESEP', JSON.stringify([{ "r": "", "s": "" }]));
            f.append('O_CONDITIONAL', JSON.stringify([{ "v1": "", "v2": "" }]));

            f.append('lvl', Cookies.get('biomedika-level'));
            f.append('id_user', Cookies.get('biomedika-csrf'));
            f.append('name', localStorage.getItem("name"));
            f.append('InputExamHistory', JSON.stringify(_InputExamHistory));
        }

        f.append('jsonRow', JSON.stringify([]));


        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        if (this.state.choosePeserta?.value == "") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "ID REG Harus Dipilih!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        } else if (this.state.peserta_dateExam == "") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Tanggal Exam Harus Diisi!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        } else if (this.state.formPerawat && _InputExamHistory.length == 0) {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Form Tidak Boleh Kosong!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        } else {

            axios({
                method: "post",
                url: uAPIlocal + "/api/v1/master_exam",
                data: f,
                headers: { 'content-type': 'multipart/form-data' }
            })
                .then((response) => {
                    console.log("ini res", response);
                    let data = response.data;

                    if (data.status == 406) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "error",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                    } else if (data.status == 200) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "success",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                            .then(function () { });

                        // if (this.state.peserta_statusSelesai != "SELESAI") {
                        //     this.setState({
                        //         modalFormLab: true
                        //     })
                        // }

                        // checkpoint disini

                        // if (this.state.formPerawat){
                        //     this.setState({
                        //         peserta_filter: {
                        //             label: "Exam",
                        //             value: "exam"
                        //         },
                        //     })
                        // }else{
                        //     this.setState({
                        //         peserta_filter: {
                        //             label: "Registrasi",
                        //             value: "registrasi"
                        //         },
                        //     })

                        this.setState({
                            peserta_filter: {
                                label: "Exam",
                                value: "exam"
                            },
                        })

                        setTimeout(() => {
                            this.getExam();
                        }, 1000);

                        this.handleCloseModalForm();
                        this.locationReload();
                    }

                })
                .catch((e) => {
                    console.error(e);
                });

        }

    }

    update_v2() {
        const _go = (event) => {
            this.updateSubmit_v2();
        };

        let BMI = this.bmiCalc(this.state.peserta_O_TINGGI, this.state.peserta_O_BERAT);

        var birthdateTimeStamp = new Date(this.state.examSelected.TANGGAL_LAHIR);
        var cur = new Date();
        var diff = cur - birthdateTimeStamp;
        var currentAge = Math.floor(diff / 31557600000);


        let log = "";
        log += "<table style='border: 1px solid black;text-align: left;'><tr><th style='padding: 10px'>Variabel</th><th style='padding: 10px'>Nilai</th></tr>"
        // response.data.results.map((item, index) => {
        //     log += "<tr>"
        //         + "<td style='font-size:14px'>" + item.message + '</td>'
        //         + "<td style='width:120px;font-size:12px; margin:6px'>" + moment(moment.utc(item.created_at)).local().format("DD-MM-YYYY HH:mm") + "<td>"
        //         + "</tr>";
        // })

        log += "<tr style='border: 1px solid black'><td style='font-size:14px;width:180px;padding: 10px'>" + "Nama" + '</td><td style="width:400px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.examSelected.NAMA_PASIEN + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Usia" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + currentAge + " Tahun" + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Jenis Kelamin" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.examSelected.JENIS_KELAMIN + "</td></tr>";

        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Pekerjaan" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_pekerjaan + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Riwayat Keluhan Utama" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_riwayatKeluhanUtama + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Riwayat Penyakit Keluarga" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_riwayatPenyakitKeluarga + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Riwayat Penyakit Dahulu" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_riwayatPenyakitDahulu + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Alergi Obat" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_riwayatAlergiObat + "</td></tr>";

        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "S" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_S + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Kesadaran (O)" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_O_KESADARAN + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Tekanan (O)" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.sistolik + "/" + this.state.diastolik + " mmHg" + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Nadi (O)" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_O_NADI + " denyut /menit" + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Suhu (O)" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_O_SUHU + " ℃" + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Pernapasan (O)" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_O_PERNAPASAN + " x /menit" + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Tinggi" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_O_TINGGI + " cm" + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Berat" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_O_BERAT + " kg" + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "BMI" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + BMI + " </td></tr>";

        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Saturasi" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_O_SATURASI + " %" + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Skala Nyeri" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_O_SKALA_NYERI + "</td></tr>";

        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "O" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_O + "</td></tr>";

        let O_CONDITIONAL = "";
        this.state.O_CONDITIONAL.map((item, index) => {
            if (item.v1 != "" || item.v2 != "") {
                O_CONDITIONAL = O_CONDITIONAL + '<li>' + item.v1 + " - " + item.v2 + '</li>';
            }
        })
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "O CONDITIONAL" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black"><ul>' + O_CONDITIONAL + "</ul></td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "A" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_A + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "P" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_P + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Catatan" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_catatan + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Status" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_statusSelesai + "</td></tr>";
        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Catatan Pemeriksaan" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_catatanPemeriksaanPenunjang + "</td></tr>";
        // log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Pembayaran Konsultasi" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_pembayaranKonsultasi + "<td></tr>";
        // log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Pembayaran Diskon" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_pembayaranDiskon + "<td></tr>";
        // log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Kontrol Ulang" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_kontrolUlang + "<td></tr>";

        let _resep = "";
        this.state.resep.map((item, index) => {
            if (item.r != "" || item.s != "") {
                _resep = _resep + '<li>' + item.r + " - " + item.s + '</li>';
            }
        })



        log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Resep Dokter" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black"><ul>' + _resep + "</ul></td></tr>";

        // log += "<tr style='border: 1px solid black'><td style='font-size:14px;padding: 10px'>" + "Surat Sakit" + '</td><td style="width:120px;font-size:12px;padding: 10px;border: 1px solid black">' + this.state.peserta_suratSakitHari + "<td></tr>";

        log += "</table>"

        Swal.fire({
            title: '<p style="font-size:24px">Review</p>',
            // icon: 'info',
            html: log,
            showConfirmButton: true,
            // showCloseButton: true,
            // showCancelButton: false,
            showCancelButton: true,
            // focusConfirm: false,
            cancelButtonText: "Cancel",
            confirmButtonText: 'Simpan',
            // confirmButtonAriaLabel: 'Simpan',
            // cancelButtonText:
            //     '<i className="fa fa-thumbs-down"></i>',
            // cancelButtonAriaLabel: 'Thumbs down'
        }).then(function (result) {
            if (result.value) {
                // console.log('good');
                // this.updateSubmit_v2.bind(this);
                _go();
            } else if (result.dismiss == 'cancel') {
                console.log('cancel');
            }

        });

    }


    updateSubmit_v2() {

        let _hours = new Date().toLocaleString("id-ID", {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });

        console.log("history lama", this.state.examSelected)

        let _InputExamHistory = [];

        if (this.state.formPerawat) {
            if (this.state.peserta_O_KESADARAN != this.state.examSelected.O_KESADARAN) {
                _InputExamHistory.push({
                    value: "Kesadaran",
                    label: this.state.peserta_O_KESADARAN,
                    recent: this.state.examSelected.O_KESADARAN,
                })
            }

            if (this.state.sistolik != this.state.examSelected.SISTOLIK || this.state.diastolik != this.state.examSelected.DIASTOLIK) {
                _InputExamHistory.push({
                    value: "Tekanan",
                    label: this.state.sistolik + "/" + this.state.diastolik + " mmHg",
                    recent: this.state.examSelected.SISTOLIK + "/" + this.state.examSelected.DIASTOLIK + " mmHg",
                })
            }

            if (this.state.peserta_O_PERNAPASAN != this.state.examSelected.O_PERNAPASAN) {
                _InputExamHistory.push({
                    value: "Pernapasan",
                    label: this.state.peserta_O_PERNAPASAN + " x /menit",
                    recent: this.state.examSelected.O_PERNAPASAN + " x /menit",
                })
            }

            if (this.state.peserta_O_NADI != this.state.examSelected.O_NADI) {
                _InputExamHistory.push({
                    value: "Nadi",
                    label: this.state.peserta_O_NADI + " denyut /menit",
                    recent: this.state.examSelected.O_NADI + " denyut /menit",
                })
            }

            if (this.state.peserta_O_BERAT != this.state.examSelected.O_BERAT) {
                _InputExamHistory.push({
                    value: "Berat",
                    label: this.state.peserta_O_BERAT + " kg",
                    recent: this.state.examSelected.O_BERAT + " kg",
                })
            }

            if (this.state.peserta_O_SUHU != this.state.examSelected.O_SUHU) {
                _InputExamHistory.push({
                    value: "Suhu",
                    label: this.state.peserta_O_SUHU + " ℃",
                    recent: this.state.examSelected.O_SUHU + " ℃",
                })
            }

            if (this.state.peserta_O_TINGGI != this.state.examSelected.O_TINGGI) {
                _InputExamHistory.push({
                    value: "Tinggi",
                    label: this.state.peserta_O_TINGGI + " cm",
                    recent: this.state.examSelected.O_TINGGI + " cm",
                })
            }

            if (this.state.peserta_O_SATURASI != this.state.examSelected.O_SATURASI) {
                _InputExamHistory.push({
                    value: "Saturasi",
                    label: this.state.peserta_O_SATURASI + " %",
                    recent: this.state.examSelected.O_SATURASI + " %",
                })
            }

            if (this.state.peserta_O_SKALA_NYERI != this.state.examSelected.O_SKALA_NYERI) {
                _InputExamHistory.push({
                    value: "Skala Nyeri",
                    label: this.state.peserta_O_SKALA_NYERI,
                    recent: this.state.examSelected.O_SKALA_NYERI,
                })
            }

        } else {
            if (this.state.peserta_O_KESADARAN != this.state.examSelected.O_KESADARAN) {
                _InputExamHistory.push({
                    value: "Kesadaran",
                    label: this.state.peserta_O_KESADARAN,
                    recent: this.state.examSelected.O_KESADARAN,
                })
            }

            if (this.state.sistolik != this.state.examSelected.SISTOLIK || this.state.diastolik != this.state.examSelected.DIASTOLIK) {
                _InputExamHistory.push({
                    value: "Tekanan",
                    label: this.state.sistolik + "/" + this.state.diastolik + " mmHg",
                    recent: this.state.examSelected.SISTOLIK + "/" + this.state.examSelected.DIASTOLIK + " mmHg",
                })
            }

            if (this.state.peserta_O_PERNAPASAN != this.state.examSelected.O_PERNAPASAN) {
                _InputExamHistory.push({
                    value: "Pernapasan",
                    label: this.state.peserta_O_PERNAPASAN + " x /menit",
                    recent: this.state.examSelected.O_PERNAPASAN + " x /menit",
                })
            }

            if (this.state.peserta_O_NADI != this.state.examSelected.O_NADI) {
                _InputExamHistory.push({
                    value: "Nadi",
                    label: this.state.peserta_O_NADI + " denyut /menit",
                    recent: this.state.examSelected.O_NADI + " denyut /menit",
                })
            }

            if (this.state.peserta_O_BERAT != this.state.examSelected.O_BERAT) {
                _InputExamHistory.push({
                    value: "Berat",
                    label: this.state.peserta_O_BERAT + " kg",
                    recent: this.state.examSelected.O_BERAT + " kg",
                })
            }

            if (this.state.peserta_O_SUHU != this.state.examSelected.O_SUHU) {
                _InputExamHistory.push({
                    value: "Suhu",
                    label: this.state.peserta_O_SUHU + " ℃",
                    recent: this.state.examSelected.O_SUHU + " ℃",
                })
            }

            if (this.state.peserta_O_TINGGI != this.state.examSelected.O_TINGGI) {
                _InputExamHistory.push({
                    value: "Tinggi",
                    label: this.state.peserta_O_TINGGI + " cm",
                    recent: this.state.examSelected.O_TINGGI + " cm",
                })
            }

            if (this.state.peserta_O_SATURASI != this.state.examSelected.O_SATURASI) {
                _InputExamHistory.push({
                    value: "Saturasi",
                    label: this.state.peserta_O_SATURASI + " %",
                    recent: this.state.examSelected.O_SATURASI + " %",
                })
            }

            if (this.state.peserta_O_SKALA_NYERI != this.state.examSelected.O_SKALA_NYERI) {
                _InputExamHistory.push({
                    value: "Skala Nyeri",
                    label: this.state.peserta_O_SKALA_NYERI,
                    recent: this.state.examSelected.O_SKALA_NYERI,
                })
            }


            if (this.state.peserta_S != this.state.examSelected.S) {
                _InputExamHistory.push({
                    value: "S",
                    label: this.state.peserta_S,
                    recent: this.state.examSelected.S,
                })
            }

            if (this.state.peserta_O != this.state.examSelected.O_FREETEXT) {
                _InputExamHistory.push({
                    value: "O",
                    label: this.state.peserta_O,
                    recent: this.state.examSelected.O_FREETEXT,
                    // task: this.state.examSelected.O_TINGGI == "" ? "input" : "update" 
                })
            }

            if (this.state.peserta_A != this.state.examSelected.A) {
                _InputExamHistory.push({
                    value: "A",
                    label: this.state.peserta_A,
                    recent: this.state.examSelected.A,
                })
            }

            if (this.state.peserta_P != this.state.examSelected.P) {
                _InputExamHistory.push({
                    value: "P",
                    label: this.state.peserta_P,
                    recent: this.state.examSelected.P,
                })
            }

            if (this.state.peserta_catatan != this.state.examSelected.CATATAN) {
                _InputExamHistory.push({
                    value: "CATATAN",
                    label: this.state.peserta_catatan,
                    recent: this.state.examSelected.CATATAN,
                })
            }

        }

        let BMI = this.bmiCalc(this.state.peserta_O_TINGGI, this.state.peserta_O_BERAT);

        // console.log("ini history", _InputExamHistory)
        console.log("ini history", this.state.resep)


        let f = new FormData();

        // alert(this.state.peserta_statusSelesai)

        if (this.state.formPerawat) {
            f.append('ID_EXAM', this.state.peserta_idExam);
            f.append('NOREG', this.state.choosePeserta?.value);
            f.append('nama_peserta', this.state.choosePeserta?.name);
            f.append('dateExam', moment(this.state.peserta_dateExam + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('YYYY-MM-DD hh:mm:ss'));
            f.append('S', this.state.examSelected.S);
            f.append('O_KESADARAN', this.state.peserta_O_KESADARAN);
            // f.append('O_TEKANAN', this.state.peserta_O_TEKANAN);
            f.append('SISTOLIK', this.state.sistolik);
            f.append('DIASTOLIK', this.state.diastolik);
            f.append('O_PERNAPASAN', this.state.peserta_O_PERNAPASAN);
            f.append('O_NADI', this.state.peserta_O_NADI);
            f.append('O_BERAT', this.state.peserta_O_BERAT);
            f.append('O_SUHU', this.state.peserta_O_SUHU);
            f.append('O_TINGGI', this.state.peserta_O_TINGGI);
            f.append('O_SATURASI', this.state.peserta_O_SATURASI);
            f.append('O_SKALA_NYERI', this.state.peserta_O_SKALA_NYERI);
            f.append('O', this.state.examSelected.O_FREETEXT);
            f.append('A', this.state.examSelected.A);
            f.append('P', this.state.examSelected.P);
            f.append('CATATAN', this.state.examSelected.CATATAN);
            f.append('dokterInput', this.state.examSelected.DOKTER_INPUT);
            f.append('statusSelesai', this.state.examSelected.STATUS);
            f.append('CATATANLAB', this.state.examSelected.CATATAN_PERIKSA_LAB);

            let _resep = [];

            console.log("this.state.resep", this.state.resep)

            if (this.state.resep.length > 0) {
                this.state.resep.map((item, index) => {
                    if (item.r != "" || item.s != "") {
                        _resep.push(item);
                    }
                })
            }


            let O_CONDITIONAL = [];

            if (this.state.O_CONDITIONAL.length > 0) {
                this.state.O_CONDITIONAL.map((item, index) => {
                    if (item.v1 != "" || item.v2 != "") {
                        O_CONDITIONAL.push(item);
                    }
                })
            }


            f.append('CATATANRESEP', JSON.stringify(_resep));
            f.append('O_CONDITIONAL', JSON.stringify(O_CONDITIONAL));
            f.append('lvl', 4);
            f.append('id_user', Cookies.get('biomedika-csrf'));
            f.append('name', localStorage.getItem("name"));
            f.append('InputExamHistory', JSON.stringify(_InputExamHistory));
            f.append("user_selected", JSON.stringify(this.state.user_selected));
            f.append('BMI', BMI);

            if (this.state.peserta_pembayaranKonsultasi == 2) {
                f.append("pembayaranDiskon", this.state.peserta_pembayaranDiskon);
                f.append("alasanDiskon", this.state.peserta_alasanDiskon);
                if (this.state.peserta_tipePasien == 1) {
                    f.append("pembayaranKonsultasi", 3);
                    f.append("tipePasien", 1);
                } else {
                    f.append("pembayaranKonsultasi", 2);
                    f.append("tipePasien", 0);
                }
            } else {
                f.append("pembayaranDiskon", 0);
                f.append("pembayaranKonsultasi", this.state.peserta_pembayaranKonsultasi);
                f.append("tipePasien", 0);
            }

            f.append("kontrolUlang", this.state.peserta_kontrolUlang);
            f.append("suratSakitHari", this.state.peserta_suratSakitHari);

            f.append("pekerjaan", this.state.peserta_pekerjaan);
            f.append("riwayatKeluhanUtama", this.state.peserta_riwayatKeluhanUtama);
            f.append("riwayatPenyakitKeluarga", this.state.peserta_riwayatPenyakitKeluarga);
            f.append("riwayatPenyakitDahulu", this.state.peserta_riwayatPenyakitDahulu);
            f.append("riwayatAlergiObat", this.state.peserta_riwayatAlergiObat);

        } else {
            // superuser & dokter
            f.append('ID_EXAM', this.state.peserta_idExam);
            f.append('NOREG', this.state.choosePeserta?.value);
            f.append('nama_peserta', this.state.choosePeserta?.name);
            f.append('dateExam', moment(this.state.peserta_dateExam + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('YYYY-MM-DD hh:mm:ss'));
            f.append('S', this.state.peserta_S);
            f.append('O_KESADARAN', this.state.peserta_O_KESADARAN);
            // f.append('O_TEKANAN', this.state.peserta_O_TEKANAN);
            f.append('SISTOLIK', this.state.sistolik);
            f.append('DIASTOLIK', this.state.diastolik);
            f.append('O_PERNAPASAN', this.state.peserta_O_PERNAPASAN);
            f.append('O_NADI', this.state.peserta_O_NADI);
            f.append('O_BERAT', this.state.peserta_O_BERAT);
            f.append('O_SUHU', this.state.peserta_O_SUHU);
            f.append('O_TINGGI', this.state.peserta_O_TINGGI);
            f.append('O_SATURASI', this.state.peserta_O_SATURASI);
            f.append('O_SKALA_NYERI', this.state.peserta_O_SKALA_NYERI);
            f.append('O', this.state.peserta_O);
            f.append('A', this.state.peserta_A);
            f.append('P', this.state.peserta_P);
            f.append('CATATAN', this.state.peserta_catatan);
            f.append('dokterInput', Cookies.get('biomedika-csrf'));
            f.append('statusSelesai', this.state.peserta_statusSelesai);
            f.append('CATATANLAB', this.state.peserta_catatanPemeriksaanPenunjang);

            // f.append('CATATANRESEP', this.state.peserta_catatanResep);
            // f.append("CATATANRESEP", stateToHTML(this.state.editorState.getCurrentContent()));

            let _resep = [];
            this.state.resep.map((item, index) => {
                if (item.r != "" || item.s != "") {
                    _resep.push(item);
                }
            })

            let O_CONDITIONAL = [];
            this.state.O_CONDITIONAL.map((item, index) => {
                if (item.v1 != "" || item.v2 != "") {
                    O_CONDITIONAL.push(item);
                }
            })

            f.append('CATATANRESEP', JSON.stringify(_resep));
            f.append('O_CONDITIONAL', JSON.stringify(O_CONDITIONAL));
            f.append('lvl', Cookies.get('biomedika-level'));
            f.append('id_user', Cookies.get('biomedika-csrf'));
            f.append('name', localStorage.getItem("name"));
            f.append('InputExamHistory', JSON.stringify(_InputExamHistory));
            f.append("user_selected", JSON.stringify(this.state.user_selected));
            f.append('BMI', BMI);

            if (this.state.peserta_pembayaranKonsultasi == 2) {
                f.append("pembayaranDiskon", this.state.peserta_pembayaranDiskon);
                f.append("alasanDiskon", this.state.peserta_alasanDiskon);
                if (this.state.peserta_tipePasien == 1) {
                    f.append("pembayaranKonsultasi", 3);
                    f.append("tipePasien", 1);
                } else {
                    f.append("pembayaranKonsultasi", 2);
                    f.append("tipePasien", 0);
                }
            } else {
                f.append("pembayaranDiskon", 0);
                f.append("pembayaranKonsultasi", this.state.peserta_pembayaranKonsultasi);
                f.append("tipePasien", 0);
            }

            f.append("kontrolUlang", this.state.peserta_kontrolUlang);
            f.append("suratSakitHari", this.state.peserta_suratSakitHari);
            f.append("pekerjaan", this.state.peserta_pekerjaan);
            f.append("riwayatKeluhanUtama", this.state.peserta_riwayatKeluhanUtama);
            f.append("riwayatPenyakitKeluarga", this.state.peserta_riwayatPenyakitKeluarga);
            f.append("riwayatPenyakitDahulu", this.state.peserta_riwayatPenyakitDahulu);
            f.append("riwayatAlergiObat", this.state.peserta_riwayatAlergiObat);
        }

        if (this.state.examSelected.REG_STATUS == "konsultasi") {
            f.append('mode', 'konsultasi');
        } else {
            f.append('mode', 'klinik');
        }

        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        if (this.state.choosePeserta?.value == "") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "ID REG Harus Dipilih!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { window.location.reload() });
        } else if (this.state.peserta_dateExam == "") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Tanggal Exam Harus Diisi!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        }
        // else if (_InputExamHistory.length == 0) {
        //     swalWithBootstrapButtons
        //         .fire({
        //             icon: "error",
        //             title: "Tidak Ada Update!",
        //             toast: true,
        //             position: "top-end",
        //             showConfirmButton: false,
        //             timer: 3000,
        //             timerProgressBar: true,
        //             didOpen: (toast) => {
        //                 toast.addEventListener("mouseenter", Swal.stopTimer);
        //                 toast.addEventListener("mouseleave", Swal.resumeTimer);
        //             },
        //         })
        //         .then(function () { });
        // } 
        else {

            axios({
                method: "put",
                url: uAPIlocal + "/api/v1/master_exam",
                data: f,
                headers: { 'content-type': 'multipart/form-data' }
            })
                .then((response) => {
                    console.log("ini res", response);
                    let data = response.data;

                    if (data.status == 406) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "error",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                    } else if (data.status == 200) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "success",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                            .then(function () {

                            });


                        this.handleCloseModalForm();
                        this.locationReload();
                    }



                })
                .catch((e) => {
                    console.error(e);
                });

        }
    }

    update_result() {

        let f = new FormData();
        f.append('ID_EXAM', this.state.peserta_idExam);
        f.append('date_result', this.state.date_result);
        f.append('lab_result_no', this.state.lab_result_no);
        f.append('NOREG', this.state.peserta_NOREG);
        f.append('hostName', uAPIlocal);

        // console.log("ini files", this.state.files)

        axios({
            method: "put",
            url: uAPIlocal + `/api/v1/master_result/${'no_upload'}`,
            data: f,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((response) => { console.log("ini res", response) })
            .catch((e) => {
                console.error(e);
            });

        let e = '';
        if (this.state.files.length == 0) {
            e = 'no_upload';
        } else {
            e = 'upload';

            this.state.files.map((file, i) => {

                f.append('File[]', file);

                axios({
                    method: "put",
                    url: uAPIlocal + `/api/v1/master_files/${e}`,
                    data: f,
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                    .then((response) => {
                        console.log("ini res", response);
                        let data = response.data;

                    })
                    .catch((e) => {
                        console.error(e);
                    });


                if (i + 1 == this.state.files.length) {

                    swalWithBootstrapButtons
                        .fire({
                            icon: "success",
                            title: "Success",
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })

                    this.handleCloseModalFormResult();
                    this.locationReload();
                }

            });

        }




    }

    getLogExam() {

        this.setState({ modalForm: false });
        this.resetForm();

        axios({
            method: "post",
            url: uAPIlocal + `/api/v1/log-exam/${this.state.peserta_idExam}`,
            // data: f,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((response) => {
                console.log("ini res", response.data);
                // let data = response.data;

                let log = "";

                log += "<table><tr><th>Aktivitas</th><th>Tanggal</th></tr>"

                response.data.results.map((item, index) => {
                    log += "<tr>"
                        + "<td style='font-size:14px'>" + item.message + '</td>'
                        + "<td style='width:120px;font-size:12px; margin:6px'>" + moment(moment.utc(item.created_at)).local().format("DD-MM-YYYY HH:mm") + "<td>"
                        + "</tr>";
                })

                log += "</table>"

                Swal.fire({
                    title: '<p style="font-size:24px">Log Aktivitas</p>',
                    // icon: 'info',
                    html: log,
                    showConfirmButton: false,
                    // showCloseButton: true,
                    // showCancelButton: false,
                    showCancelButton: true,
                    focusConfirm: false,
                    cancelButtonText: "CANCEL",
                    // confirmButtonText:
                    //     '<i className="fa fa-thumbs-up"></i> Ok!',
                    // confirmButtonAriaLabel: 'Ok!',
                    // cancelButtonText:
                    //     '<i className="fa fa-thumbs-down"></i>',
                    // cancelButtonAriaLabel: 'Thumbs down'
                }).then(function (result) {
                    if (result.value) {
                        console.log('good');
                    } else if (result.dismiss == 'cancel') {
                        console.log('cancel');
                    }

                });

            })
            .catch((e) => {
                console.error(e);
            });


    }


    changeSelect = (e) => {
        console.log('change', e)
        this.setState({ chooseDept: e })
    }

    changeSelectPeserta = (e) => {
        console.log('change', e)
        this.setState({ choosePeserta: e })
    }

    handleSelect(key) {
        this.setState({ tabkey: key });
    }

    changeSelectFilter = (e) => {
        console.log('change', e)

        this.setState({ tableInbox: false })
        this.setState({ peserta_filter: e })

        if (e.value == "exam") {
            this.getExam();
        } else {
            this.getPatient();
        }

        // setTimeout(() => {

        //     if (e.value == "exam") {
        //         this.getExam();
        //     } else {
        //         this.getPatient();
        //     }

        //     this.setState({
        //         tableInbox: true
        //     })
        // }, 4000);

    }







    deleteRowPatient(id, n) {
        this.setState({ _delSwalPatient: true, _editFormActive: false, _resultFormActive: false })
        Swal.fire({
            text: "Apakah Anda yakin menghapus " + n + "?",
            toast: true,
            showCancelButton: true,
            confirmButtonText: "Hapus",
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteDataPatient(id);
            } else {
                this.setState({ _delSwalPatient: false, detailClicked: false, showModal: false })
                // this.setState({
                //     //   _swalDel: false,
                //     //   val_dailyreport: [],
                // });
            }
        });
    }

    deleteRowFile(id, n) {
        this.setState({ _delSwalPatient: true, _editFormActive: false, _resultFormActive: false })
        Swal.fire({
            text: "Apakah Anda yakin menghapus file?",
            toast: true,
            showCancelButton: true,
            confirmButtonText: "Hapus",
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteDataFile(id);
            } else {
                this.setState({ _delSwalPatient: false, detailClicked: false, showModal: false })
                // this.setState({
                //     //   _swalDel: false,
                //     //   val_dailyreport: [],
                // });
            }
        });
    }

    deleteDataPatient(p, t) {
        let f = new FormData();
        f.append('ID_EXAM', p);
        axios({
            method: "delete",
            url: uAPIlocal + "/api/v1/master_exam/",
            data: f,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
            .then((response) => {
                swalWithBootstrapButtons
                    .fire({
                        icon: "success",
                        title: "berhasil dihapus",
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 1000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener("mouseenter", Swal.stopTimer);
                            toast.addEventListener("mouseleave", Swal.resumeTimer);
                        },
                    })
                    .then(function () {
                        // location.reload()
                    });

                this.locationReload();


            })
            .catch((e) => {
                console.error(e);
            });
    };

    deleteDataFile(id) {
        let f = new FormData();
        f.append('ID_FILE', id);
        axios({
            method: "delete",
            url: uAPIlocal + "/api/v1/master_files/",
            data: f,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
            .then((response) => {
                swalWithBootstrapButtons
                    .fire({
                        icon: "success",
                        title: "berhasil dihapus",
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 1000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener("mouseenter", Swal.stopTimer);
                            toast.addEventListener("mouseleave", Swal.resumeTimer);
                        },
                    })
                    .then(function () {
                        // location.reload()
                    });

                this.locationReload();


            })
            .catch((e) => {
                console.error(e);
            });
    };

    getIDdokter(id) {
        // alert(id)
        let f = new FormData();
        f.append('id_dokter', id);
        axios({
            method: "post",
            url: uAPIlocal + "/api/v1/getiddokter/",
            data: f,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
            .then((response) => {

                var row = response.data.results[0];
                this.setState({ getIDdokter: row.id })
            })
            .catch((e) => {
                console.error(e);
            });
    };


    getDownload() {
        this.setState({ _goDownload: true })
        setTimeout(() => {
            this.setState({
                _goDownload: false,
                detailClicked: false,
                showModal: false,
                _delSwalPatient: false,
                _editFormActive: false,
                _resultFormActive: false,
                clr_child: true
            })
        }, 1000);

    }




    locationReload() {
        this.setState({ tableInbox: false })
        this.getExam();
        // setTimeout(() => {
        //     this.setState({
        //         tableInbox: true
        //     })
        // }, 2000);
    };

    maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    suratSakitCheck = (object) => {
        if (object.target.value > 3) {
            object.target.value = 3
        }

        if (object.target.value < 0) {
            object.target.value = 0
        }
    }

    copasP = () => {
        const blocksFromHTML1 = convertFromHTML('<p>' + this.state.peserta_P + '</p>');
        const state1 = ContentState.createFromBlockArray(
            blocksFromHTML1.contentBlocks,
            blocksFromHTML1.entityMap,
        );

        this.setState({
            editorState: EditorState.createWithContent(state1),
        });
    }

    //   batas fungsi

    render() {

        if (this.state.redirctTo) {
            localStorage.clear();
            sessionStorage.clear();
            Cookies.remove("biomedika-login", { path: '/', domain: '.biomedika.co.id' })
            // Cookies.remove("biomedika-login", { path: '/' })
        } else { }

        const emptyDataMessage = () => { return (<p style={{ textAlign: 'center', marginTop: '20px' }}>Tidak ada data</p>); }
        const onChangePembayaranKonsultasi = (e) => {
            console.log(`radio checked:${e.target.value}`);
            this.setState({ peserta_pembayaranKonsultasi: e.target.value });

            if (e.target.value == "1") {
                alert("Perhatian, Anda tidak mendapatkan bayaran dari biaya konsultasi FREE.")
            }
        };

        const onChangeTipePasien = (e) => {
            this.setState({ peserta_tipePasien: e.target.value });
        };

        const onChangePembayaranDiskon = (e) => {
            this.setState({ peserta_pembayaranDiskon: e.target.value });
        };

        const onChangeKontrolUlang = (e) => {
            this.setState({ peserta_kontrolUlang: e.target.value });
        };


        const onChangeSkalaNyeri = (e) => {
            this.setState({ peserta_O_SKALA_NYERI: e.target.value });
        };

        var birthdateTimeStamp = new Date(this.state.examSelected.TANGGAL_LAHIR);
        var cur = new Date();
        var diff = cur - birthdateTimeStamp;
        var currentAge = Math.floor(diff / 31557600000);

        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name} - {file.size} bytes
            </li>
        ));

        const { editorState } = this.state;
        const { tableInbox } = this.state;
        const { historyExam } = this.state;
        const columns = [
            {
                dataField: "id",
                text: "",
                style: (cell, row, rowIndex) => {

                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "20px",
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "20px",
                            textAlign: 'center',
                        };
                    }
                },
                headerAttrs: {
                    hidden: false
                },

                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', width: '20px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    const _info = (event) => {
                        this.setState({
                            showInfo: true,
                            dataDetail: row
                        })
                    };

                    const _print = (event) => {
                        console.log("happyhappy", row);
                        this.setState({ _goPlayAudio: true })
                        setTimeout(() => {
                            this.setState({
                                showModal: false,
                                _goPlayAudio: false,
                                _delSwalPatient: false,
                                _editFormActive: false,
                                clr_child: true
                            })
                        }, 1000);
                    };

                    // alert(moment((new Date().toLocaleString())).local().format("YYYY-MM-DD hh:mm:ss"));
                    // alert(moment(moment.utc(row.DATE_EXAM, 'YYYY-MM-DD hh:mm:ss')).local().format("YYYY-MM-DD"))

                    const _edit = (event) => {
                        console.log("happyhappy2", row);



                        let indexPeserta = this.state.optPeserta.findIndex(function (item, i) {
                            return item.value == row.NOREG
                        });

                        let status = "";

                        if (Cookies.get('biomedika-level') == 2 && row.STATUS == "Selesai Diperiksa Perawat") {
                            status = "SELESAI";
                            this.getUserBranch(1, row.branch_code);
                            setTimeout(() => {
                                this.getUserBranch(4, row.branch_code);
                            }, 1000);
                        } else {
                            status = row.STATUS;
                        }


                        this.setState({
                            modalForm: true,
                            peserta_idExam: row.ID_EXAM,
                            choosePeserta: this.state.optPeserta[indexPeserta],
                            peserta_NOREG: row.NOREG,
                            peserta_NAMA_PASIEN: row.NAMA_PASIEN,
                            peserta_dateExam: moment(moment.utc(row.DATE_EXAM, 'YYYY-MM-DD hh:mm:ss')).local().format("YYYY-MM-DD"),
                            // moment(row.DATE_EXAM, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                            peserta_diagnosaPrimary: row.DIAGNOSA_PRIMARY,
                            // peserta_diagnosaSecondary: row.DIAGNOSA_SECONDARY,
                            peserta_S: row.S,
                            peserta_O_KESADARAN: row.O_KESADARAN,
                            // peserta_O_TEKANAN: row.O_TEKANAN,
                            sistolik: row.SISTOLIK,
                            diastolik: row.DIASTOLIK,
                            peserta_O_PERNAPASAN: row.O_PERNAPASAN,
                            peserta_O_NADI: row.O_NADI,
                            peserta_O_BERAT: row.O_BERAT,
                            peserta_O_SUHU: row.O_SUHU,
                            peserta_O_TINGGI: row.O_TINGGI,
                            peserta_O_SATURASI: row.O_SATURASI,
                            peserta_O_SKALA_NYERI: row.O_SKALA_NYERI,
                            peserta_O: row.O_FREETEXT,
                            peserta_A: row.A,
                            peserta_P: row.P,
                            peserta_catatan: row.CATATAN,
                            peserta_dokterInput: row.DOKTER_INPUT,
                            peserta_dokterInputName: row.name,
                            peserta_statusSelesai: status,
                            peserta_catatanPemeriksaanPenunjang: row.CATATAN_PERIKSA_LAB,
                            peserta_catatanResep: row.CATATAN_RESEP,
                            resep: row.CATATAN_RESEP ? JSON.parse(row.CATATAN_RESEP) : [],
                            peserta_O_CONDITIONAL: row.O_CONDITIONAL,
                            O_CONDITIONAL: row.O_CONDITIONAL ? JSON.parse(row.O_CONDITIONAL) : [],
                            dateExamHour: moment(row.DATE_REGISTRASI, 'hh:mm:ss').format("hh:mm:ss"),
                            tabkey: 1,
                            _editFormActive: true,
                            _resultFormActive: false,
                            updateBtnV2: true,
                            examSelected: row,
                            peserta_pembayaranKonsultasi: row.PEMBAYARAN_KONSULTASI,
                            peserta_pembayaranDiskon: row.PEMBAYARAN_DISKON,
                            peserta_alasanDiskon: row.ALASAN_DISKON,
                            peserta_tipePasien: row.TIPE_PASIEN,
                            peserta_kontrolUlang: row.KONTROL_ULANG,
                            peserta_suratSakitHari: row.SURAT_SAKIT_HARI,
                            peserta_BMI: row.BMI,
                            peserta_pekerjaan: row.PEKERJAAN,
                            peserta_riwayatKeluhanUtama: row.RIWAYAT_KELUHAN_UTAMA,
                            peserta_riwayatPenyakitKeluarga: row.RIWAYAT_PENYAKIT_KELUARGA,
                            peserta_riwayatPenyakitDahulu: row.RIWAYAT_PENYAKIT_DAHULU,
                            peserta_riwayatAlergiObat: row.RIWAYAT_ALERGI_OBAT,
                        })

                        if (row.CATATAN_RESEP) {
                            const blocksFromHTML1 = convertFromHTML(row.CATATAN_RESEP);
                            const state1 = ContentState.createFromBlockArray(
                                blocksFromHTML1.contentBlocks,
                                blocksFromHTML1.entityMap,
                            );

                            this.setState({
                                editorState: EditorState.createWithContent(state1),
                            });
                        }



                    };

                    const _result = (event) => {
                        console.log("happyhappy3", row);

                        let indexPeserta = this.state.optPeserta.findIndex(function (item, i) {
                            return item.value === row.ID_REGISTRASI
                        });

                        let dateResult = "";
                        if (row.date_result == '0000-00-00 00:00:00' || row.date_result == null) {
                            dateResult = moment().format('YYYY-MM-DDTHH:mm');
                        } else {
                            dateResult = moment.utc(new Date(row.date_result).toLocaleString()).format('YYYY-MM-DDTHH:mm');
                        }

                        this.setState({
                            modalFormResult: true,
                            peserta_idExam: row.ID_EXAM,
                            choosePeserta: this.state.optPeserta[indexPeserta],
                            peserta_dateExam: moment(row.DATE_EXAM, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                            ID_REGISTRASI: row.ID_REGISTRASI,
                            NAMA_PASIEN: row.NAMA_PASIEN,
                            peserta_S: row.S,
                            peserta_O_KESADARAN: row.O_KESADARAN,
                            // peserta_O_TEKANAN: row.O_TEKANAN,
                            sistolik: row.SISTOLIK,
                            diastolik: row.DIASTOLIK,
                            peserta_O_PERNAPASAN: row.O_PERNAPASAN,
                            peserta_O_NADI: row.O_NADI,
                            peserta_O_BERAT: row.O_BERAT,
                            peserta_O_SUHU: row.O_SUHU,
                            peserta_O_TINGGI: row.O_TINGGI,
                            peserta_O_SATURASI: row.O_SATURASI,
                            peserta_O_SKALA_NYERI: row.O_SKALA_NYERI,
                            peserta_O: row.O_FREETEXT,
                            peserta_A: row.A,
                            peserta_P: row.P,
                            peserta_catatan: row.CATATAN,
                            peserta_dokterInput: row.DOKTER_INPUT,
                            peserta_dokterInputName: row.name,
                            date_result: dateResult,
                            lab_result_file: row.lab_result_file,
                            lab_result_no: row.lab_result_no,
                            dateExamHour: moment(row.DATE_REGISTRASI, 'hh:mm:ss').format("hh:mm:ss"),
                            tabkey: 1,
                            _resultFormActive: true,
                            updateBtnV2: true,
                        })
                    };

                    const _delete = (event) => {
                        // alert(row.id);
                        console.log("happyhappy", row);
                        this.deleteRowPatient(row.ID_EXAM, row.NAMA_PASIEN);
                    };

                    const _log = (event) => {
                        console.log("happyhappy", row);
                        this.setState({
                            peserta_idExam: row.ID_EXAM,
                            tabkey: 1,
                            _resultFormActive: true,
                            updateBtnV2: true,
                        }, () => this.getLogExam())
                    };



                    return (

                        <ul className="list-inline m-0 d-flex justify-content-center">
                            <li className="list-inline-item"
                                style={{
                                    display: (Cookies.get('biomedika-level') == 2 || Cookies.get('biomedika-level') == 3 || Cookies.get('biomedika-level') == 4) ? null : 'none',
                                    cursor: moment(new Date().toLocaleString()).local().format("YYYY-MM-DD") == moment(moment.utc(row.DATE_EXAM, 'YYYY-MM-DD hh:mm:ss')).local().format("YYYY-MM-DD") ? null : 'not-allowed'
                                }}
                            >
                                <button


                                    disabled={this.getDateRange(moment(moment.utc(row.DATE_EXAM, 'YYYY-MM-DD hh:mm:ss')).local().format("YYYY-MM-DD"), moment(new Date().toLocaleString()).local().format("YYYY-MM-DD")) > 5 && (row.STATUS == "PERIKSA LAB" || row.STATUS == "SELESAI" || row.last_return_status == "PERIKSA LAB") ? true : false}
                                    className={this.getDateRange(moment(moment.utc(row.DATE_EXAM, 'YYYY-MM-DD hh:mm:ss')).local().format("YYYY-MM-DD"), moment(new Date().toLocaleString()).local().format("YYYY-MM-DD")) > 5 && (row.STATUS == "PERIKSA LAB" || row.STATUS == "SELESAI" || row.last_return_status == "PERIKSA LAB") ? "btn btn-light btn-sm rounded-0" : "btn btn-success btn-sm rounded-0"}
                                    // className="btn btn-success btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Input Pemeriksaan"
                                    onClick={_edit}
                                    style={{ backgroundImage: this.getDateRange(moment(moment.utc(row.DATE_EXAM, 'YYYY-MM-DD hh:mm:ss')).local().format("YYYY-MM-DD"), moment(new Date().toLocaleString()).local().format("YYYY-MM-DD")) > 5 && (row.STATUS == "PERIKSA LAB" || row.STATUS == "SELESAI" || row.last_return_status == "PERIKSA LAB") ? "url(" + _editDocB + ")" : "url(" + _editDoc + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                >
                                    {/* <i className="fa fa-edit" /> */}
                                </button>
                            </li>
                            <li className="list-inline-item">
                                <button
                                    className="btn btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Detail Pasien"
                                    onClick={_info}
                                    // style={{ width: '30px' }}
                                    style={{ backgroundImage: "url(" + _infoDoc + ")", backgroundColor: '#2E5984', backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                >
                                    {/* <i className="fa fa-info" /> */}
                                </button>
                            </li>


                            <li className="list-inline-item">
                                <div onClick={_print}>
                                    <ButtonPrintResep item={row} />
                                </div>
                            </li>

                            <li className="list-inline-item">
                                <div onClick={_print}>
                                    <ButtonPrintSuratSakit item={row} />
                                </div>
                            </li>


                            {/* <li className="list-inline-item">
                                <div onClick={_print}>
                                    <ButtonPrintLab item={row} />
                                </div>
                            </li> */}



                            <li className="list-inline-item">
                                <button
                                    className="btn btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Input Result"
                                    onClick={_result}
                                    style={{ backgroundImage: "url(" + _pdf + ")", backgroundColor: '#00CDAC', backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                >
                                    {/* <i className="fa fa-file-pdf-o" /> */}
                                </button>
                            </li>

                            <li className="list-inline-item">
                                <button
                                    className="btn btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Log Aktivitas"
                                    onClick={_log}
                                    style={{ backgroundImage: "url(" + _clock + ")", backgroundColor: '#FFAE19', backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                >
                                    {/* <i className="fa fa-clock-o" /> */}
                                </button>
                            </li>

                            {/* <li className="list-inline-item">
                                <button
                                    className="btn btn-danger btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Delete"
                                    onClick={_delete}
                                >
                                    <i className="fa fa-trash" />
                                </button>
                            </li> */}

                        </ul>

                    );
                },
            },

            {
                dataField: "NOMR",
                text: "STATUS PERIKSA",
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "20px",
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "20px",
                            textAlign: 'center',
                        };
                    }
                },
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    if (row.STATUS == "PERIKSA LAB" || row.STATUS == "SELESAI" || row.last_return_status == "PERIKSA LAB") {
                        return (
                            <h5 style={{ textAlign: 'center' }}>
                                <Badge bg="success">
                                    Diperiksa
                                </Badge>
                            </h5>
                        )
                    } else {
                        return (
                            <h5 style={{ textAlign: 'center' }}>
                                <Badge bg="danger">
                                    Belum Diperiksa
                                </Badge>
                            </h5>
                        )
                    }


                },
            },

            {
                dataField: "NOMR",
                text: "STATUS PASIEN",
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "20px",
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "20px",
                            textAlign: 'center',
                        };
                    }
                },
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {

                    if (row.regCount > 1) {
                        return (
                            <h5 style={{ textAlign: 'center' }}>
                                <Badge bg="dark" style={{}}>
                                    Kontrol
                                </Badge>
                            </h5>

                        )
                    } else {
                        return (
                            <h5 style={{ textAlign: 'center', }}>
                                <Badge bg="light" text="dark" style={{ border: '2px solid black', borderRadius: '6px' }}>
                                    Baru
                                </Badge>
                            </h5>
                        )
                    }


                },
            },

            {
                dataField: "NOMR",
                text: "STATUS REGISTRASI",
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "20px",
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "20px",
                            textAlign: 'center',
                        };
                    }
                },
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return (
                            <h5 style={{ textAlign: 'center' }}>
                                <Badge bg="dark">
                                    Konsultasi
                                </Badge>
                            </h5>
                        )
                    } else {
                        return (
                            <h5 style={{ textAlign: 'center' }}>
                                <Badge bg="light" text="dark" style={{ border: '2px solid black', borderRadius: '6px' }}>
                                    Klinik
                                </Badge>
                            </h5>
                        )
                    }


                },
            },

            {
                dataField: "NOMR",
                text: "NO. MR",
                // formatter: this.imgFormatter,
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    }
                },
                headerAttrs: {
                    hidden: false
                },
                // formatter: this.handleRowsClick,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', textAlign: 'center', color: "#fff" };
                },
            },
            {
                dataField: "NOREG",
                text: "NO. REG",
                // formatter: this.imgFormatter,
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    }
                },
                headerAttrs: {
                    hidden: false
                },
                // formatter: this.handleRowsClick,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', textAlign: 'center', color: "#fff" };
                },
            },
            {
                dataField: "NAMA_PASIEN",
                text: "NAMA",
                // formatter: this.imgFormatter,
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                        };
                    }
                },
                headerAttrs: {
                    hidden: false
                },
                formatter: this.handleRowsClick,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', textAlign: 'center', color: "#fff" };
                },
            },
            {
                dataField: "DATE_EXAM",
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    }
                },
                text: "TANGGAL PEMERIKSAAN",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    if (row.DATE_EXAM == '0000-00-00 00:00:00' || row.DATE_EXAM == null) {
                        return (
                            <>
                                0000-00-00 00:00:00
                            </>
                        )
                    } else {
                        return (
                            <>
                                {moment(moment.utc(row.DATE_EXAM)).local().format("DD-MM-YYYY HH:mm")}
                            </>
                        )
                    }

                },
            },
            {
                dataField: "date_result",
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    }
                },
                text: "DATE RESULT",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    if (row.date_result == '0000-00-00 00:00:00' || row.date_result == null) {
                        return (
                            <>
                                0000-00-00 00:00:00
                            </>
                        )
                    } else {
                        return (
                            <>
                                {moment(moment.utc(row.date_result)).local().format("DD-MM-YYYY HH:mm")}
                            </>
                        )
                    }

                },
            },
            {
                dataField: "lab_result_no",
                text: "RESULT NO.",
                // formatter: this.imgFormatter,
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    }
                },
                headerAttrs: {
                    hidden: false
                },
                formatter: this.handleRowsClick,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', textAlign: 'center', color: "#fff" };
                },
            },
            {
                dataField: "lab_result_file",
                text: "RESULT",
                // formatter: this.imgFormatter,
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "12px",
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    }
                },
                headerAttrs: {
                    hidden: false
                },
                formatter: (cell, row, rowIndex) => {
                    // if (row.lab_result_file) {
                    //     return (
                    //         <a className="btn" style={{ fontSize: '14px' }} onClick={() => this.getDownload()} target="_blank" href={row.lab_result_file}><i className="fa fa-file-pdf-o"></i> {row.lab_result_file_name != "" ? row.lab_result_file_name.substring(0, 15) + "..." : row.lab_result_file_name}</a>
                    //     )
                    // } else {
                    //     return (
                    //         <></>
                    //     )
                    // }

                    const _deleteFile = (id) => {
                        this.deleteRowFile(id)
                    };

                    console.log('row.FILES1', row);

                    if (row.FILES) {
                        console.log('row.FILES2', row.FILES)
                        // console.log('ini result', result);
                        if (row.FILES.length > 0) {
                            return <ul>
                                {row.FILES.map((item, i) => {
                                    return <li style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', listStyleType: 'none' }}>
                                        <a className="btn" style={{ fontSize: '14px', textAlign: 'left' }} onClick={() => this.getDownload()} target="_blank" href={item.lab_result_file}>
                                            <img
                                                // src={_pdf}
                                                style={{ backgroundImage: "url(" + _pdf + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "20px", height: "20px" }}
                                            />
                                            {" "}{item.lab_result_file_name != "" ? item.lab_result_file_name.substring(0, 24) + "..." : item.lab_result_file_name}
                                        </a>
                                        <button onClick={() => _deleteFile(item.id)}>delete</button>
                                    </li>
                                })}
                            </ul>
                        } else {
                            return <></>
                        }
                    }


                },
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '400px', textAlign: 'center', color: "#fff" };
                },
            },


            // {
            //     dataField: "name",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "Dokter Input",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },


        ];


        const columnsR = [
            {
                dataField: "id",
                text: "",
                style: (cell, row, rowIndex) => {

                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "20px",
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "20px",
                            textAlign: 'center',
                        };
                    }
                },
                headerAttrs: {
                    hidden: false
                },
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', width: '20px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {

                    const _print = (event) => {
                        console.log("happyhappy", row);
                        this.setState({ _goPlayAudio: true })
                        setTimeout(() => {
                            this.setState({
                                showModal: false, _goPlayAudio: false, _delSwalPatient: false, _editFormActive: false, clr_child: true
                            })
                        }, 1000);
                    };

                    const _add = (event) => {
                        console.log("happyhappyadd", row);

                        let indexDokter = this.state.optDokter.findIndex(function (item, i) {
                            return item.value === row.DPJP
                        });

                        let indexPeserta = this.state.optPeserta.findIndex(function (item, i) {
                            return item.value == row.NOREG
                        });

                        this.setState({
                            modalForm: true,
                            choosePeserta: this.state.optPeserta[indexPeserta],
                            chooseDokter: this.state.optDokter[indexDokter],
                            tabkey: 1,
                            _editFormActive: true,
                            _resultFormActive: false,
                            examSelected: row,
                            // updateBtnV2: true,
                        }, () => this.getIDdokter(row.DPJP))
                    };

                    return (
                        <div onClick={_print} style={{ display: Cookies.get('biomedika-level') == 3 || Cookies.get('biomedika-level') == 4 ? 'flex' : 'none' }} >
                            <TextPost item={row} />
                            <div style={{ display: (Cookies.get('biomedika-level') == 3 || Cookies.get('biomedika-level') == 4) && row.return_request != 2 ? null : 'none' }}>
                                <button
                                    className="btn btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Add"
                                    style={{ width: '30px', height: "30px", display: row.ANTRIAN_DOKTER == "" ? 'none' : null, backgroundColor: 'purple', backgroundImage: "url(" + _pencil + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
                                    onClick={_add}
                                >
                                    {/* <i className="fa fa-pencil" /> */}
                                </button>
                            </div>
                        </div>
                    );
                },
            },


            {
                dataField: "NAMA_PASIEN",
                style: (cell, row, rowIndex) => {

                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textAlign: 'center'
                        };
                    }
                },
                text: "NAMA",
                sort: true,
                formatter: this.handleRowsClick,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
            },
            {
                dataField: "NOMR",
                style: (cell, row, rowIndex) => {

                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            textAlign: 'center'
                        };
                    }
                },
                text: "NO. MR",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
            },
            {
                dataField: "NOREG",
                style: (cell, row, rowIndex) => {

                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            textAlign: 'center'
                        };
                    }
                },
                text: "NO. REGISTRASI",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
            },

            {
                dataField: "ALAMAT",
                style: (cell, row, rowIndex) => {

                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            textAlign: 'center'
                        };
                    }
                },
                text: "ALAMAT",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    return (
                        <>
                            {row.alamatPasien.substring(0, 80) + '...'}
                        </>
                    )
                },
            },

            {
                dataField: "ALAMAT",
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            fontWeight: 'normal',
                            margin: '2px auto',
                            fontSize: '12px',
                            textAlign: 'center'
                        };
                    }
                },
                text: "TANGGAL LAYANAN",
                sort: true,
                headerStyle: (colum, colIndex) => {

                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    return (
                        <span style={{ color: moment(moment(moment.utc(row.TGL_LAYANAN)).local().format("YYYY-MM-DD")).isSame(moment().format('YYYY-MM-DD')) == true ? "black" : 'red', fontWeight: 'bold' }}>
                            {moment(moment(moment.utc(row.TGL_LAYANAN)).local().format("YYYY-MM-DD")).isSame(moment().format('YYYY-MM-DD')) == true ? "Today" : moment(moment.utc(row.TGL_LAYANAN)).local().format("YYYY-MM-DD")}
                        </span>
                    )
                },
            },

            {
                dataField: "NOMR",
                text: "STATUS REGISTRASI",
                style: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return {
                            width: "20px",
                            textAlign: 'center',
                            backgroundColor: "#89CFF0"
                        };
                    } else {
                        return {
                            width: "20px",
                            textAlign: 'center',
                        };
                    }
                },
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return (
                            <h5 style={{ textAlign: 'center' }}>
                                <Badge bg="dark">
                                    Konsultasi
                                </Badge>
                            </h5>
                        )
                    } else {
                        return (
                            <h5 style={{ textAlign: 'center' }}>
                                <Badge bg="light" text="dark" style={{ border: '2px solid black', borderRadius: '6px' }}>
                                    Klinik
                                </Badge>
                            </h5>
                        )
                    }


                },
            },

        ];


        const pageButtonRenderer = ({
            page,
            active,
            disable,
            title,
            onPageChange
        }) => {
            const handleClick = (e) => {
                e.preventDefault();
                onPageChange(page);
            };

            console.log("pageACTIVEX", title)
            if (title != "Pre page") {
                if (title != "First page")
                    if (active) {
                        return (
                            <li className="paginationSectionList">
                                <a href="#" className="paginationSectionLinkActive" onClick={handleClick} >{page}</a>
                            </li>
                        );
                    } else {

                        return (
                            <li className="paginationSectionList">
                                <a href="#" className="paginationSectionLink" onClick={handleClick} >{page}</a>
                            </li>
                        );

                    }

            }

        };




        const options = {
            pageButtonRenderer,
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: "First",
            prePageText: "Back",
            nextPageText: "Next",
            lastPageText: "Last",
            nextPageTitle: "First page",
            prePageTitle: "Pre page",
            firstPageTitle: "Next page",
            lastPageTitle: "Last page",
            withFirstAndLast: false,
            alwaysShowAllBtns: false,
            showTotal: true,
            totalSize: this.state.datas.length,
            // hidePageListOnlyOnePage:
        };

        const tableRowEvents = {
            onClick: (e, row, rowIndex) => {
                switch (e.detail) {
                    case 1:
                        console.log("click");
                        handleShow(row)
                        handleRowClick(rowIndex)
                        break;
                    case 2:
                        console.log("double click");
                        break;
                    case 3:
                        console.log("triple click");
                        break;
                }
            },
            onMouseEnter: (e, row, rowIndex) => {
                // console.log('onMouseEnter', e);
                // console.log('onMouseEnter', row);
                // console.log('onMouseEnter', rowIndex);
            },
        };

        const handleRowClick = (row) => {
            this.setState({ selectedRows: row });
        };

        const formattedAge = (age) => {
            var from = age.split("/");
            var birthdateTimeStamp = new Date(from[2], from[1] - 1, from[0]);
            var cur = new Date();
            var diff = cur - birthdateTimeStamp;
            // This is the difference in milliseconds
            var currentAge = Math.floor(diff / 31557600000);
            return currentAge + " " + "Tahun";
        }

        const handleShow = (data) => {
            // var id_company = localStorage.getItem("Company_ID");
            if (this.state.peserta_filter?.value != 'registrasi') {
                this.stopInterval();
                this.fetchDataDetail(data.NOMR)
            } else {
                this.stopInterval();
                this.fetchDataDetail(data.NOMR)
                this.setState({
                    showInfo: true,
                    dataDetail: data
                })
            }

            // alert(data.NOMR)
        }


        const ModalDetail = ({ paginationProps, paginationTableProps, isTemuan }) => {
            console.log('isTemuan', isTemuan)
            // console.log('this.state.dataDetail', this.state.dataDetail)
            return (

                <div className="position-absolute" style={{ top: "50px", zIndex: 99, }} ref={this.modalRef} id="slide" >

                    <div className="shadow rounded zindex-fixed overflow-scroll mr-3 peopleSubColumn1" style={{ backgroundColor: '#EFEFEF' }}   >

                        <button className="btnCloseTable" onClick={this.handleCloseModalDetail()}></button>



                        <div className="scroll_div" style={{ display: this.state.showInfo ? null : 'none' }}>
                            <table className="table">
                                <thead style={{ position: 'relative' }}>
                                    <tr>
                                        <th style={{ padding: '10px' }} colSpan={2}>
                                            <p style={{ marginBottom: '0px', textAlign: 'center', fontSize: '12px' }}>Data Registrasi</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr >
                                        <td style={{ width: '240px' }}>
                                            No. MR
                                        </td>
                                        <td>: {this.state.dataDetail.NOMR}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            No. Registrasi
                                        </td>
                                        <td>: {this.state.dataDetail.NOREG}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Tanggal Registrasi
                                        </td>
                                        <td>: {moment(moment.utc(this.state.dataDetail.DATE_REGISTRASI)).local().format("DD MMMM YYYY - hh:mm")}</td>

                                    </tr>

                                    <tr>
                                        <td>
                                            Tanggal Layanan
                                        </td>
                                        <td>: {moment(moment.utc(this.state.dataDetail.TGL_LAYANAN)).local().format("DD MMMM YYYY")}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Jam Layanan
                                        </td>
                                        <td>: {this.state.dataDetail.JAM_LAYANAN}</td>
                                    </tr>


                                    <tr style={{ display: this.state.dataDetail.JANJI_HASIL == "0000-00-00" ? "none" : null }}>
                                        <td>
                                            Tanggal Janji Hasil
                                        </td>
                                        <td>: {moment(moment.utc(this.state.dataDetail.JANJI_HASIL)).local().format("DD MMMM YYYY")}</td>
                                    </tr>

                                    <tr style={{ display: this.state.dataDetail.RETURN_DATE == "0000-00-00" ? "none" : null }}>
                                        <td>
                                            Tanggal Balik
                                        </td>
                                        <td>: {moment(moment.utc(this.state.dataDetail.RETURN_DATE)).local().format("DD MMMM YYYY")}</td>
                                    </tr>


                                    <tr>
                                        <td>
                                            Kontrol Ulang
                                        </td>
                                        <td>: {this.state.dataDetail.KONTROL_ULANG == 1 ? "Iya" : "Tidak"}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            No. Antrian
                                        </td>
                                        <td>: {this.state.dataDetail.ANTRIAN_DOKTER}</td>
                                    </tr>

                                </tbody>
                            </table>

                            <table className="table">
                                <thead style={{ position: 'relative' }}>
                                    <tr>
                                        <th style={{ padding: '10px' }} colSpan={2}>
                                            <p style={{ marginBottom: '0px', textAlign: 'center', fontSize: '12px' }}>Data Pasien</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ width: '240px' }}>
                                            Nama
                                        </td>
                                        <td>: {this.state.dataDetail.NAMA_PASIEN}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            NIK
                                        </td>
                                        <td>: {this.state.dataDetail.NIK}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Jenis Kelamin
                                        </td>
                                        <td>: {this.state.dataDetail.JENIS_KELAMIN}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Tempat/Tanggal Lahir
                                        </td>
                                        <td>: {this.state.dataDetail.TEMPAT_LAHIR + ", " + moment(moment.utc(this.state.dataDetail.TANGGAL_LAHIR)).local().format("DD MMMM YYYY")}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Alamat
                                        </td>
                                        <td>: {this.state.dataDetail.alamatPasien}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            No. Telp
                                        </td>
                                        <td>: {this.state.dataDetail.NO_TELP}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Email
                                        </td>
                                        <td>: {this.state.dataDetail.EMAIL}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Pekerjaan
                                        </td>
                                        <td>: {this.state.dataDetail.PEKERJAAN}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Riwayat Keluhan Utama
                                        </td>
                                        <td>: {this.state.dataDetail.RIWAYAT_KELUHAN_UTAMA}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Riwayat Penyakit Keluarga
                                        </td>
                                        <td>: {this.state.dataDetail.RIWAYAT_PENYAKIT_KELUARGA}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Riwayat Penyakit Dahulu
                                        </td>
                                        <td>: {this.state.dataDetail.RIWAYAT_PENYAKIT_DAHULU}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Riwayat Alergi Obat
                                        </td>
                                        <td>: {this.state.dataDetail.RIWAYAT_ALERGI_OBAT}</td>
                                    </tr>




                                    {/* <tr>
                                        <td>
                                            Prioritas
                                        </td>
                                        <td>: {this.state.dataDetail.PRIORITAS}</td>
                                    </tr> */}
                                    {/* <tr>
                                        <td>
                                            NO. Bukti Layanan
                                        </td>
                                        <td>: {this.state.dataDetail.NO_BUKTI_LAYANAN}</td>
                                    </tr> */}



                                </tbody>
                            </table>


                        </div>


                        <div style={{ display: this.state.showInfo ? 'none' : null }}>
                            <Tabs
                                defaultActiveKey={this.state.historyExamID[0]}
                                id="uncontrolled-tab-example"
                                className="mb-3 myTab"

                            >
                                {


                                    this.state.historyExamID.map((item, index) => {

                                        console.log("ini render item " + index, this.state.historyExam[index])

                                        return (

                                            // <Tab eventKey={item} title={moment(moment.utc(item.DATE_EXAM)).local().format("DD/MM/YYYY")} className="scroll_tab">
                                            <Tab eventKey={item} title={item} className="scroll_tab">

                                                <div style={{ margin: '10px' }}>
                                                    {this.state.historyExam[index] ?

                                                        this.state.historyExam[index].map((subItem, i) => {

                                                            { console.log("ini render subitem", subItem.O_BERAT) }

                                                            return (


                                                                <table className="table">
                                                                    <thead style={{ position: 'relative' }}>
                                                                        <tr>
                                                                            <th style={{ padding: '10px' }} colSpan={2}>

                                                                                {i == 0 ? (index == 0 ?


                                                                                    (<p style={{ marginBottom: '0px', textAlign: 'center', fontSize: '12px' }}>{"KONTROL ULANG (" + moment(moment.utc(subItem.DATE_EXAM)).local().format("DD-MM-YYYY") + ")"}</p>
                                                                                    ) :


                                                                                    (<p style={{ marginBottom: '0px', textAlign: 'center', fontSize: '12px' }}>{"BARU (" + moment(moment.utc(subItem.DATE_EXAM)).local().format("DD-MM-YYYY") + ")"}</p>
                                                                                    )


                                                                                )


                                                                                    : (

                                                                                        <p style={{ marginBottom: '0px', textAlign: 'center', fontSize: '12px' }}>{"BACA HASIL (" + moment(moment.utc(subItem.DATE_EXAM)).local().format("DD-MM-YYYY") + ")"}</p>

                                                                                    )

                                                                                }

                                                                            </th>

                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>

                                                                        <tr>
                                                                            <td>
                                                                                Riwayat Keluhan Utama
                                                                            </td>
                                                                            <td>: {subItem.RIWAYAT_KELUHAN_UTAMA}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                Riwayat Penyakit Keluarga
                                                                            </td>
                                                                            <td>: {subItem.RIWAYAT_PENYAKIT_KELUARGA}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                Riwayat Penyakit Dahulu
                                                                            </td>
                                                                            <td>: {subItem.RIWAYAT_PENYAKIT_DAHULU}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                Riwayat Alergi Obat
                                                                            </td>
                                                                            <td>: {subItem.RIWAYAT_ALERGI_OBAT}</td>
                                                                        </tr>

                                                                        <tr >
                                                                            <td style={{ width: '220px' }}>
                                                                                Kesadaran
                                                                            </td>
                                                                            <td>: {subItem.O_KESADARAN}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                Tekanan Darah
                                                                            </td>
                                                                            {/* <td>: {subItem.O_TEKANAN + " mmHg"}</td> */}
                                                                            <td>: {subItem.SISTOLIK + "/" + subItem.DIASTOLIK + " mmHg"}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                Nadi
                                                                            </td>
                                                                            <td>: {subItem.O_NADI + " denyut /menit"}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                Suhu
                                                                            </td>
                                                                            <td>: {subItem.O_SUHU + " ℃"}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                Pernapasan
                                                                            </td>
                                                                            <td>: {subItem.O_PERNAPASAN + " x /menit"}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                Tinggi Badan
                                                                            </td>
                                                                            <td>: {subItem.O_TINGGI + " cm"}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                Berat Badan
                                                                            </td>
                                                                            <td>: {subItem.O_BERAT + " kg"}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                Saturasi
                                                                            </td>
                                                                            <td>: {subItem.O_SATURASI + " %"}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                Skala Nyeri
                                                                            </td>
                                                                            <td>: {subItem.O_SKALA_NYERI}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                S (Subjective)
                                                                            </td>
                                                                            <td>: {subItem.S}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                O (Objective)
                                                                            </td>
                                                                            <td>: {subItem.O_FREETEXT}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                A (Assessment)
                                                                            </td>
                                                                            <td>: {subItem.A}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                P (Plan)
                                                                            </td>
                                                                            <td>: {subItem.P}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                Catatan
                                                                            </td>
                                                                            <td>: {subItem.CATATAN}</td>
                                                                        </tr>

                                                                        <tr style={{ display: subItem.STATUS == "SELESAI" ? "none" : null }}>
                                                                            <td>
                                                                                Catatan Pemeriksaan Penunjang
                                                                            </td>
                                                                            <td>: {subItem.CATATAN_PERIKSA_LAB}</td>
                                                                        </tr>

                                                                        {/* <tr>
                                                                            <td>
                                                                                DIAGNOSA PRIMARY
                                                                            </td>
                                                                            <td>: {subItem.DIAGNOSA_PRIMARY}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                DIAGNOSA SECONDARY
                                                                            </td>
                                                                            <td>: {subItem.DIAGNOSA_SECONDARY}</td>
                                                                        </tr> */}

                                                                        {/* <tr>
                                                                            <td>
                                                                                DOKTER INPUT
                                                                            </td>
                                                                            <td>: {subItem.name}</td>
                                                                        </tr> */}


                                                                    </tbody>
                                                                </table>

                                                            )
                                                        })

                                                        : null
                                                    }
                                                </div>
                                            </Tab>


                                        );


                                    })

                                }


                            </Tabs>

                        </div>


                    </div>


                </div >

            )
        }

        const MySearch = (props) => {
            // console.log(props, "propss")
            let input;
            const handleClick = (e) => {
                // alert("jah")
                // console.log(input, "input isis")
                // console.log(e.target.value, "value input")
                // console.log(this.state.searchValue, "search value from mysearch")
                props.onSearch(this.input.value);
                // this.setState({ searchWord: e.target.value })
                // console.log(input.value, "")
            };

            const handleFocus = (e) => {
                // alert("jah");
                this.stopInterval();
            };

            const handleOnBlur = (e) => {
                // alert("jah");
                this.playInterval();
            };

            const handleClear = (e) => {
                // console.log(input, "input isis")
                // console.log(e.target.value, "value input")
                // console.log(this.state.searchValue, "search value from mysearch")
                props.onSearch("");
                this.input.value = "";
            };

            return (
                <>
                    <InputGroup className="mb-3">
                        {/* <input
              className="form-control border-right-0 border"
              style={{ backgroundColor: "white", padding: 0 }}
              ref={(n) => (input = n)}
              type="text"
            />
            <button
              className="btn btn-tropical-rain-forest"
              onClick={handleClick}
            >
              Search
            </button> */}
                        {/* <input ref={(n) => (console.log(n, "n value"))} onChange={handleClick} type="text" className="search-query form-control" value={this.props.location.state ? this.props?.location?.state?.Patient_ID : ""} placeholder="   Search" /> */}


                        <div className="input-group" style={{ width: '100%' }}>
                            <input
                                ref={myinput => (this.input = myinput)}
                                onChange={handleClick}
                                onFocus={handleFocus}
                                onBlur={handleOnBlur}
                                type="text" style={{ borderRadius: '50px' }} className="search-query form-control" value={this.state.searchValue} placeholder="   Search" />
                            {/* <span className="input-group-btn">
                    <button type="button" disabled>
                      <span className="fa fa-search"></span>
                    </button>
                  </span> */}

                            <span className="clr_child" style={{ display: this.state.clr_child ? null : 'none' }} >
                                <button type="button" className="clr_img_btn" onClick={handleClear}>
                                    {/* <span className="fa fa-search"></span> */}
                                </button>
                            </span>
                        </div>



                    </InputGroup>
                </>
            );
        };



        const contentTableInbox = ({ paginationProps, paginationTableProps }) => {
            return (
                <div>
                    <ToolkitProvider keyField="id" columns={this.state.peserta_filter?.value == "exam" ? columns : columnsR} data={this.state.datas} search={{
                        defaultSearch: this.state.searchValue ? this.state.searchValue : ''
                    }}>
                        {(toolkitprops) => (
                            <div>



                                <div className="row justify-content-end" >
                                    {/* <div className="col-6">
                                        <p>Hi</p>
                                    </div> */}


                                    <Col className="">
                                        <ButtonGroup>
                                            {/* <button className="btn btn-primary btn-sm" onClick={() => this.openModalAddForm()}>
                                                <i className="fa fa-plus" /> Add Exam
                                            </button> */}

                                            {/* <button className="btn btn-primary btn-sm" onClick={() => this.setState({ modalForm: true, addPatientPeriode: true, tabkey: 2 })}>
                                                <i className="fa fa-plus" /> Add Period
                                            </button>
                                            <button className="btn btn-primary btn-sm" onClick={() => this.setState({ modalAddResult: true })}>
                                                <i className="fa fa-plus" /> Add Result
                                            </button>
                                            <button className="btn btn-primary btn-sm" onClick={() => this.setState({ modalAddTemuan: true })}>
                                                <i className="fa fa-plus" /> Add Temuan
                                            </button> */}

                                            {/* <select
                                                name="peserta_filter"
                                                // className="form-control"
                                                onChange={this.changeSelectFilter}
                                                value={this.state.peserta_filter}
                                                style={{ fontSize: '12px' }}
                                            >
                                                <option value="registrasi">REGISTRASI</option>
                                                <option value="exam">EXAM</option>

                                            </select> */}

                                            <Select
                                                className='title'
                                                value={this.state.peserta_filter}
                                                name="dept"
                                                options={[
                                                    {
                                                        label: "Registrasi",
                                                        value: "registrasi"
                                                    },
                                                    {
                                                        label: "Exam",
                                                        value: "exam"
                                                    },
                                                ]}
                                                placeholder="Pilih Registrasi"
                                                onChange={this.changeSelectFilter}
                                                menuPosition={'fixed'}


                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 2 }),
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                        color: "#000",
                                                        // backgroundColor: 'rgba(231,230,227,255)',
                                                        // borderRadius: '10px',
                                                        width: "180px",
                                                        fontSize: '12px',
                                                    }),
                                                    option: provided => ({
                                                        ...provided,
                                                        fontSize: '12px',
                                                        zIndex: 2,
                                                    }),
                                                    dropdownIndicator: styles => ({
                                                        ...styles,
                                                        color: '#000',
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        minHeight: 1,
                                                    }),
                                                    indicatorSeparator: () => null,
                                                }}
                                            />

                                        </ButtonGroup>
                                    </Col>


                                    <Col>
                                        <MySearch  {...toolkitprops.searchProps} />
                                    </Col>

                                </div>



                                <Row className="justify-content-end">




                                </Row>

                                <div className="peopleColumn" style={{ overflowY: this.state.datas.length == 0 ? null : 'scroll' }}>
                                    {this.state.detailClicked && this.state.showModal && !this.state._delSwalPatient && !this.state._editFormActive && !this.state._resultFormActive && !this.state._goPlayAudio && <ModalDetail isTemuan />}

                                    <BootstrapTable
                                        striped
                                        bordered={false}
                                        hover
                                        // selectRow={selectRow}
                                        {...toolkitprops.baseProps}
                                        {...paginationTableProps}
                                        rowEvents={tableRowEvents}
                                        noDataIndication={emptyDataMessage}
                                    // wrapperClasses="table-responsive"

                                    />
                                </div>


                                <div className="paginationSection">
                                    {paginationProps.page == 1 ? <button disabled="true" className="paginationSectionButtonPrev" onClick={this.handlePrevPage(paginationProps)}></button> : (<button className="paginationSectionButtonPrev" onClick={this.handlePrevPage(paginationProps)}></button>)}
                                    <PaginationListStandalone
                                        {...paginationProps}
                                    />

                                    {paginationProps.page != this.state._totalPage ? (
                                        <>
                                            <ul className="pagination react-bootstrap-table-page-btns-ul">
                                                <li className="paginationSectionList">
                                                    <a href="#" className="paginationSectionLink">...</a>
                                                </li>
                                            </ul>
                                            <ul className="pagination react-bootstrap-table-page-btns-ul">
                                                <li className="paginationSectionList">
                                                    <a onClick={this.handleLastPage(paginationProps)} href="#" className="paginationSectionLink">{this.state._totalPage}</a>
                                                </li>
                                            </ul></>) : null}

                                    {paginationProps.page == this.state._totalPage ? <button disabled="true" className="paginationSectionButtonNext" onClick={this.handleNextPage(paginationProps)}></button> : <button className="paginationSectionButtonNext" onClick={this.handleNextPage(paginationProps)}></button>}
                                </div>


                            </div>
                        )}
                    </ToolkitProvider>
                </div >
            );
        }

        const selectRow = {
            mode: "checkbox",
            style: { backgroundColor: "#c8e6c9" },
            selectColumnStyle: {
                width: 20,
            },
            selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) input.indeterminate = indeterminate;
                    }}
                    {...rest}
                />
            ),
            selectionRenderer: ({ mode, ...rest }) => (
                <input
                    // style={{width:20}}
                    type={mode}
                    {...rest}
                />
            ),
        };


        // back
        if (this.state.redirect === true && this.state.action === true) {
            return (<Redirect to={{
                pathname: this.state.pathname,
                state: {
                    id: this.state.idSelected,
                    prevPage: this.state.prevPage,
                    prevState: this.state.prevState,
                    goTo: this.state.goTo,
                }
            }} />)
        }

        return (
            <>
                <div id="clearOverlay" style={{ display: this.state.tableInbox == true ? "none" : "flex" }}>
                    <div className="w-100 d-flex justify-content-center align-items-center">
                        <div className="sk-chase">
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                        </div>
                    </div>
                </div>

                <Modal
                    show={this.state.modalForm}
                    onHide={this.handleCloseModalForm.bind(this)}
                    backdrop="static"
                    size={this.state.formPerawat ? "lg" : 'xl'}
                    dialogClassName={this.state.formPerawat ? "custom-modal-sm2" : "custom-modal"}
                    keyboard
                    centered
                >
                    <Modal.Header
                        className={Cookies.get('biomedika-level') == 4 ? null : "text-center bg-darkGreenExam rounded-top h-[50]"} closeButton>
                        {/* <Modal.Title>ADD Exam</Modal.Title> */}
                        <div className="container" style={{ display: Cookies.get('biomedika-level') == 4 ? 'none' : null }}>
                            <div className="row justify-content-center ">

                                <div className="col-6">
                                    <div className="d-flex flex-row gap-4">
                                        <div className="flex-column text-start" style={{ color: "#EFEFEF" }}>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Nama</div>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Usia</div>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Jenis Kelamin</div>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Kesadaran</div>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Tekanan</div>

                                            {/* <div>PID </div> */}
                                        </div>
                                        <div className="flex-column text-start" style={{ color: "#EFEFEF" }}>
                                            <div style={{ fontSize: 12 }}>: {this.state.examSelected.NAMA_PASIEN}</div>
                                            <div style={{ fontSize: 12 }}>: {currentAge} Tahun</div>
                                            <div style={{ fontSize: 12 }}>: {this.state.examSelected.JENIS_KELAMIN}</div>
                                            <div style={{ fontSize: 12 }}>: {this.state.examSelected.O_KESADARAN}</div>
                                            <div style={{ fontSize: 12 }}>: {this.state.examSelected.SISTOLIK + "/" + this.state.examSelected.DIASTOLIK + " mmHg"}</div>
                                            {/* <div>: asd</div> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="d-flex flex-row gap-4">
                                        <div className="flex-column text-start" style={{ color: "#EFEFEF" }}>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Nadi</div>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Suhu</div>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Pernapasan</div>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Tinggi Badan</div>
                                            <div style={{ fontWeight: '600', fontSize: 12 }}>Berat Badan</div>
                                            {/* <div>PID </div>  */}
                                        </div>
                                        <div className="flex-column text-start" style={{ color: "#EFEFEF" }}>
                                            <div style={{ fontSize: 12 }}>: {this.state.examSelected.O_NADI + " denyut /menit"}</div>
                                            <div style={{ fontSize: 12 }}>: {this.state.examSelected.O_SUHU + " ℃"}</div>
                                            <div style={{ fontSize: 12 }}>: {this.state.examSelected.O_PERNAPASAN + " x /menit"}</div>
                                            <div style={{ fontSize: 12 }}>: {this.state.examSelected.O_TINGGI + " cm"}</div>
                                            <div style={{ fontSize: 12 }}>: {this.state.examSelected.O_BERAT + " kg"}</div>
                                            {/* <div>: asd</div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <table style={{ display: Cookies.get('biomedika-level') == 4 ? null : 'none' }}>
                            <tbody>
                                <tr>
                                    <td> <p style={{ fontWeight: 'bold', margin: '0px' }}>ADD EXAM</p></td>
                                </tr>
                                <tr>
                                    {
                                        localStorage.getItem("branch") ?
                                            (
                                                <td><span style={{ fontSize: 12 }}>{localStorage.getItem("name")} - {this.state.optBranch ? this.state.optBranch.find(el => el.value == localStorage.getItem("branch")).label : null}</span></td>
                                            ) :

                                            <></>
                                    }
                                </tr>
                            </tbody>
                        </table>


                    </Modal.Header>
                    <Modal.Body
                        style={{ marginBottom: '-30px' }}
                    >
                        <Tab.Container id="left-tabs-example" activeKey={this.state.tabkey}>
                            <Row>
                                <Col md={12}>
                                    <Nav
                                        variant="tabs"
                                    // defaultActiveKey="/home"
                                    // style={{ marginLeft: 8, marginRight: 8 }}
                                    >
                                        <Nav.Item>
                                            <Nav.Link
                                                eventKey={1}
                                                onClick={() => this.handleSelect(1)}
                                            // style={{ display: this.state.addPatientPeriode ? 'none' : null }}
                                            >
                                                Data Pasien
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                // disabled
                                                eventKey={2}
                                                onClick={() => this.handleSelect(2)}
                                                style={{ display: this.state.formPerawat ? 'none' : null }}
                                            >
                                                Tindak Lanjut
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                // disabled
                                                eventKey={3}
                                                onClick={() => this.handleSelect(3)}
                                                style={{ display: this.state.formPerawat ? 'none' : null }}
                                            >
                                                Resep
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                // disabled
                                                eventKey={4}
                                                onClick={() => this.handleSelect(4)}
                                                style={{ display: this.state.formPerawat ? 'none' : null }}
                                            >
                                                Surat Sakit
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col>
                                    <Tab.Content style={{ marginTop: 20 }}>
                                        <Tab.Pane eventKey={1} >
                                            <form action="#" encType="multipart/form-data" id="form_add">
                                                <div className="form-content" style={{ display: this.state.formPerawat ? 'none' : null }}>
                                                    <div className="row">
                                                        <div className="col-md-6">

                                                            {/* <div className="form-group">
                                                                <label className="form-label">Peserta</label>
                                                                <Select
                                                                    className='title'
                                                                    value={this.state.choosePeserta}
                                                                    // isDisabled={this.state.updateBtnV2 ? true : false}
                                                                    isDisabled={true}
                                                                    name="dept"
                                                                    options={this.state.optPeserta}
                                                                    placeholder="Pilih Peserta"
                                                                    onChange={this.changeSelectPeserta}
                                                                    menuPosition={'fixed'}
                                                                    isReadOnly={this.state.updateBtnV2 ? true : null}

                                                                    styles={{
                                                                        menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                            color: "#000",
                                                                            backgroundColor: 'white',
                                                                            borderRadius: '10px',
                                                                            // width: "140px",
                                                                            fontSize: '12px',
                                                                        }),
                                                                        option: provided => ({
                                                                            ...provided,
                                                                            fontSize: '12px',
                                                                            zIndex: 999,
                                                                        }),
                                                                        dropdownIndicator: styles => ({
                                                                            ...styles,
                                                                            color: '#000',
                                                                        }),
                                                                        indicatorsContainer: (base) => ({
                                                                            ...base,
                                                                            minHeight: 1,
                                                                        }),
                                                                        indicatorSeparator: () => null,
                                                                    }}
                                                                />
                                                            </div> */}

                                                            {/* <div className="form-group">
                                                                <label className="form-label">Tanggal Pemeriksaan</label>
                                                                <input
                                                                    type="date"
                                                                    name="peserta_dateExam"
                                                                    // defaultValue={new Date().toISOString().slice(0, 10)}
                                                                    className="form-control"
                                                                    value={moment(new Date(this.state.peserta_dateExam)).format("YYYY-MM-DD")}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div> */}

                                                            <div className="form-group">
                                                                <label className="form-label">Pekerjaan</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_pekerjaan"
                                                                    className="form-control"
                                                                    value={this.state.peserta_pekerjaan}
                                                                    onChange={this.onChange}
                                                                // readOnly={true}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Riwayat Keluhan Utama</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="peserta_riwayatKeluhanUtama"
                                                                    value={this.state.peserta_riwayatKeluhanUtama}
                                                                    style={{ height: '60px' }}
                                                                    onChange={this.onChange}
                                                                // readOnly={true}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Riwayat Penyakit Keluarga</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="peserta_riwayatPenyakitKeluarga"
                                                                    value={this.state.peserta_riwayatPenyakitKeluarga}
                                                                    style={{ height: '60px' }}
                                                                    onChange={this.onChange}
                                                                // readOnly={true}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Riwayat Penyakit Dahulu</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="peserta_riwayatPenyakitDahulu"
                                                                    value={this.state.peserta_riwayatPenyakitDahulu}
                                                                    style={{ height: '60px' }}
                                                                    onChange={this.onChange}
                                                                // readOnly={true}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Riwayat Alergi Obat</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="peserta_riwayatAlergiObat"
                                                                    value={this.state.peserta_riwayatAlergiObat}
                                                                    style={{ height: '60px' }}
                                                                    onChange={this.onChange}
                                                                // readOnly={true}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">S (Subjective)</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_S"
                                                                    value={this.state.peserta_S}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                />
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <label className="form-label">Kesadaran</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="peserta_O_KESADARAN"
                                                                            value={this.state.peserta_O_KESADARAN}
                                                                            onChange={this.onChange}
                                                                        />
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    {/* <div className="form-group">
                                                                        <label className="form-label">Tekanan Darah</label>
                                                                        <div className="input-group mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="peserta_O_TEKANAN"
                                                                                value={this.state.peserta_O_TEKANAN}
                                                                                onChange={this.onChange}
                                                                                maxLength="7"
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <span className="input-group-text">mmHg</span>
                                                                            </div>
                                                                        </div>
                                                                    </div> */}


                                                                    <div className="row">
                                                                        <label className="form-label">Tekanan Darah</label>
                                                                        <div className="col-4">
                                                                            <div className="form-group">
                                                                                <label className="form-label"></label>
                                                                                <div className="input-group mb-3">

                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        name="sistolik"
                                                                                        value={this.state.sistolik}
                                                                                        onChange={this.onChange}
                                                                                        maxLength="7"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-1">
                                                                            <div className="form-group">
                                                                                <label className="form-label"></label>
                                                                                <div className="input-group mb-3">
                                                                                    <span>/</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-7">
                                                                            <div className="form-group">
                                                                                <label className="form-label"></label>
                                                                                <div className="input-group mb-3">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        name="diastolik"
                                                                                        value={this.state.diastolik}
                                                                                        onChange={this.onChange}
                                                                                        maxLength="7"
                                                                                    />
                                                                                    <div className="input-group-append">
                                                                                        <span className="input-group-text">mmHg</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                                <div className="col-md-5">
                                                                    <div className="form-group">
                                                                        <label className="form-label">Suhu</label>
                                                                        <div className="input-group mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="peserta_O_SUHU"
                                                                                value={this.state.peserta_O_SUHU}
                                                                                onChange={this.onChange}
                                                                                onInput={this.maxLengthCheck}
                                                                                maxLength="6"
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <span className="input-group-text">℃</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-7">
                                                                    <div className="form-group">
                                                                        <label className="form-label">Pernapasan</label>
                                                                        <div className="input-group mb-3">
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                name="peserta_O_PERNAPASAN"
                                                                                value={this.state.peserta_O_PERNAPASAN}
                                                                                onChange={this.onChange}
                                                                                onInput={this.maxLengthCheck}
                                                                                maxLength="2"
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <span className="input-group-text">x /menit</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                            </div>


                                                        </div>

                                                        <div className="col-md-6">

                                                            <div className="row">




                                                                <div className="form-group">
                                                                    <label className="form-label">Nadi</label>
                                                                    <div className="input-group mb-3">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            name="peserta_O_NADI"
                                                                            value={this.state.peserta_O_NADI}
                                                                            onChange={this.onChange}
                                                                            onInput={this.maxLengthCheck}
                                                                            maxLength="3"
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <span className="input-group-text"> denyut /menit</span>
                                                                            {/* <span className="input-group-text">bpm</span> */}
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                <div className="form-group">
                                                                    <label className="form-label">Saturasi Oksigen</label>

                                                                    <div className="input-group mb-3">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="peserta_O_SATURASI"
                                                                            value={this.state.peserta_O_SATURASI}
                                                                            onChange={this.onChange}
                                                                            onInput={this.maxLengthCheck}
                                                                            maxLength="7"
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <span className="input-group-text">%</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>


                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="form-label">Tinggi Badan</label>
                                                                        <div className="input-group mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="peserta_O_TINGGI"
                                                                                value={this.state.peserta_O_TINGGI}
                                                                                onChange={this.onChange}
                                                                                onInput={this.maxLengthCheck}
                                                                                maxLength="3"
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <span className="input-group-text">cm</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="form-label">Berat Badan</label>

                                                                        <div className="input-group mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="peserta_O_BERAT"
                                                                                value={this.state.peserta_O_BERAT}
                                                                                onChange={this.onChange}
                                                                                onInput={this.maxLengthCheck}
                                                                                maxLength="3"
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <span className="input-group-text">kg</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                {/* 
                                                                <div className="col-12">
                                                                    <div className="form-group">
                                                                        <label className="form-label text-center">Skala Nyeri</label>

                                                                        <div className="d-flex justify-content-center">
                                                                            <Radio.Group
                                                                                className="radio-custom"
                                                                                value={this.state.peserta_O_SKALA_NYERI}
                                                                                onChange={onChangeSkalaNyeri}
                                                                            >
                                                                                <Radio value="0">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_0}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="1">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_1}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="2">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_2}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="3">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_3}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="4">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_4}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="5">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_5}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="6">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_6}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="7">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_7}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="8">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_8}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="9">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_9}
                                                                                    />
                                                                                </Radio>
                                                                                <Radio value="10">
                                                                                    <img
                                                                                        alt=" "
                                                                                        width={40}
                                                                                        height={40}
                                                                                        src={painscale_10}
                                                                                    />
                                                                                </Radio>
                                                                            </Radio.Group>
                                                                        </div>

                                                                        <div className="d-flex justify-content-center">
                                                                            <img
                                                                                alt=" "
                                                                                width={100}
                                                                                height={100}
                                                                                src={painscale_info}
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                </div> */}

                                                                <div className="form-group">
                                                                    <label className="form-label">BMI</label>

                                                                    <div className="input-group mb-3">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="peserta_BMI"
                                                                            value={this.state.peserta_BMI}
                                                                            readOnly={true}
                                                                        />
                                                                    </div>
                                                                </div>



                                                            </div>


                                                            <div className="form-group">
                                                                <label className="form-label">O (Objective)</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_O"
                                                                    value={this.state.peserta_O}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                />
                                                            </div>

                                                            <div className="d-flex flex-column">


                                                                <form style={{ marginBottom: 10 }}>
                                                                    {this.createUI2()}

                                                                    <button
                                                                        className="btn btn-info btn-sm "
                                                                        style={{ backgroundColor: '#0f7051', backgroundImage: "url(" + plus + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                                                        type="button"
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                        title="add more"
                                                                        onClick={this.addClick2}
                                                                    >
                                                                    </button>
                                                                </form>

                                                            </div>


                                                            <div className="form-group">
                                                                <label className="form-label">A (Assessment)</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_A"
                                                                    value={this.state.peserta_A}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">P (Plan)</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_P"
                                                                    value={this.state.peserta_P}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                />
                                                            </div>


                                                            {/* <div className="form-group">
                                                                <label className="form-label">DIAGNOSA PRIMARY</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_diagnosaPrimary"
                                                                    value={this.state.peserta_diagnosaPrimary}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '80px' }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">DIAGNOSA SECONDARY</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_diagnosaSecondary"
                                                                    value={this.state.peserta_diagnosaSecondary}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '80px' }}
                                                                />
                                                            </div> */}

                                                            <div className="form-group">
                                                                <label className="form-label">Catatan</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_catatan"
                                                                    value={this.state.peserta_catatan}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '100px' }}
                                                                />
                                                            </div>


                                                            {/* <div className="form-group">
                                                                <label className="form-label">Dokter</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_petugasInput"
                                                                    required
                                                                    value={this.state.updateBtnV2 ? this.state.peserta_dokterInputName : localStorage.getItem("name")}
                                                                    onChange={this.onChange}
                                                                    readOnly={true}
                                                                />
                                                            </div> */}

                                                            {/* <div className="form-group">
                                                                <label className="form-label">DOKTER INPUT</label>
                                                                <input
                                                                    type="number"
                                                                    name="peserta_dokterInput"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_dokterInput}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div> */}


                                                        </div>


                                                    </div>



                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-group" style={{}}>
                                                                <label className="form-label text-center">Skala Nyeri</label>

                                                                <div className="d-flex justify-content-center">
                                                                    <Radio.Group
                                                                        className="radio-custom"
                                                                        value={this.state.peserta_O_SKALA_NYERI}
                                                                        onChange={onChangeSkalaNyeri}
                                                                    >
                                                                        <Radio value="0">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_0}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="1">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_1}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="2">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_2}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="3">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_3}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="4">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_4}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="5">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_5}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="6">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_6}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="7">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_7}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="8">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_8}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="9">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_9}
                                                                            />
                                                                        </Radio>
                                                                        <Radio value="10">
                                                                            <img
                                                                                alt=" "
                                                                                width={58}
                                                                                height={58}
                                                                                src={painscale_10}
                                                                            />
                                                                        </Radio>
                                                                    </Radio.Group>
                                                                </div>

                                                                <div className="d-flex justify-content-center">
                                                                    <img
                                                                        alt=" "
                                                                        width={100}
                                                                        // height={100}
                                                                        src={painscale_info}
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>

                                                <div className="form-content" style={{ display: this.state.formPerawat ? null : 'none' }}>
                                                    <div className="row">
                                                        <div className="col-md-6">


                                                            <div className="form-group">
                                                                <label className="form-label">Kesadaran</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_O_KESADARAN"
                                                                    value={this.state.peserta_O_KESADARAN}
                                                                    onChange={this.onChange}

                                                                />
                                                            </div>

                                                            <div className="row">
                                                                <label className="form-label">Tekanan Darah</label>
                                                                <div className="col-4">
                                                                    <div className="form-group">
                                                                        <label className="form-label"></label>
                                                                        <div className="input-group mb-3">

                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="sistolik"
                                                                                value={this.state.sistolik}
                                                                                onChange={this.onChange}
                                                                                maxLength="7"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-1">
                                                                    <div className="form-group">
                                                                        <label className="form-label"></label>
                                                                        <div className="input-group mb-3">
                                                                            <span>/</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-7">
                                                                    <div className="form-group">
                                                                        <label className="form-label"></label>
                                                                        <div className="input-group mb-3">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="diastolik"
                                                                                value={this.state.diastolik}
                                                                                onChange={this.onChange}
                                                                                maxLength="7"
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <span className="input-group-text">mmHg</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* <div className="form-group">
                                                                <label className="form-label">Tekanan Darah</label>

                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="peserta_O_TEKANAN"
                                                                        value={this.state.peserta_O_TEKANAN}
                                                                        onChange={this.onChange}
                                                                        maxLength="7"
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <span className="input-group-text">mmHg</span>
                                                                    </div>
                                                                </div>
                                                            </div> */}

                                                            <div className="form-group">
                                                                <label className="form-label">Nadi</label>
                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        name="peserta_O_NADI"
                                                                        value={this.state.peserta_O_NADI}
                                                                        onChange={this.onChange}
                                                                        onInput={this.maxLengthCheck}
                                                                        maxLength="3"
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <span className="input-group-text">denyut /menit</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Suhu</label>
                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="peserta_O_SUHU"
                                                                        value={this.state.peserta_O_SUHU}
                                                                        onChange={this.onChange}
                                                                        onInput={this.maxLengthCheck}
                                                                        maxLength="6"
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <span className="input-group-text">℃</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="form-label">Pernapasan</label>
                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        name="peserta_O_PERNAPASAN"
                                                                        value={this.state.peserta_O_PERNAPASAN}
                                                                        onChange={this.onChange}
                                                                        onInput={this.maxLengthCheck}
                                                                        maxLength="2"
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <span className="input-group-text">x /menit</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Tinggi Badan</label>
                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="peserta_O_TINGGI"
                                                                        value={this.state.peserta_O_TINGGI}
                                                                        onChange={this.onChange}
                                                                        onInput={this.maxLengthCheck}
                                                                        maxLength="3"
                                                                        style={{ marginTop: 8 }}
                                                                    />
                                                                    <div className="input-group-append" style={{ marginTop: 8 }}>
                                                                        <span className="input-group-text">cm</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Berat Badan</label>

                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="peserta_O_BERAT"
                                                                        value={this.state.peserta_O_BERAT}
                                                                        onChange={this.onChange}
                                                                        onInput={this.maxLengthCheck}
                                                                        maxLength="3"
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <span className="input-group-text">kg</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Saturasi Oksigen</label>

                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="peserta_O_SATURASI"
                                                                        value={this.state.peserta_O_SATURASI}
                                                                        onChange={this.onChange}
                                                                        onInput={this.maxLengthCheck}
                                                                        maxLength="7"
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <span className="input-group-text">%</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>


                                                        <div className="form-group">
                                                            <label className="form-label text-center">Skala Nyeri</label>

                                                            <div className="d-flex justify-content-center">
                                                                <Radio.Group
                                                                    className="radio-custom"
                                                                    value={this.state.peserta_O_SKALA_NYERI}
                                                                    onChange={onChangeSkalaNyeri}
                                                                >
                                                                    <Radio value="0">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_0}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="1">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_1}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="2">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_2}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="3">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_3}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="4">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_4}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="5">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_5}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="6">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_6}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="7">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_7}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="8">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_8}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="9">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_9}
                                                                        />
                                                                    </Radio>
                                                                    <Radio value="10">
                                                                        <img
                                                                            alt=" "
                                                                            width={40}
                                                                            height={40}
                                                                            src={painscale_10}
                                                                        />
                                                                    </Radio>
                                                                </Radio.Group>
                                                            </div>

                                                            <div className="d-flex justify-content-center">
                                                                <img
                                                                    alt=" "
                                                                    width={100}
                                                                    height={100}
                                                                    src={painscale_info}
                                                                />
                                                            </div>

                                                        </div>



                                                    </div>
                                                </div>

                                            </form>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey={2}>
                                            <form action="#" encType="multipart/form-data" id="form_add">
                                                <div className="form-content">

                                                    <span style={{ fontSize: 14, margin: 0, padding: 0, fontWeight: 'bold', fontStyle: 'italic' }}>(Jika SOAP kosong mohon diisi dihalaman sebelumnya)</span>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="form-label">S</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_S"
                                                                    value={this.state.peserta_S}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                    readOnly={true}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">O</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_O"
                                                                    value={this.state.peserta_O}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">

                                                            <div className="form-group">
                                                                <label className="form-label">A</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_A"
                                                                    value={this.state.peserta_A}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                    readOnly={true}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">P</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_P"
                                                                    value={this.state.peserta_P}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                    readOnly={true}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            {/* <div className="form-group">
                                                                <label className="form-label">Perlu Periksa Lab?</label>
                                                                <select
                                                                    name="peserta_statusSelesai"
                                                                    className="form-control"
                                                                    onChange={this.onChangeStatusSelesai}
                                                                    value={this.state.peserta_statusSelesai}
                                                                >
                                                                    <option value="SELESAI">Tidak Perlu (Selesai)</option>
                                                                    <option disabled={this.state.examSelected.REG_STATUS == "konsultasi" ? true : false} value="PERIKSA LAB">Lanjut Periksa Lab</option>
                                                                </select>
                                                            </div> */}

                                                            <div className="form-group">
                                                                <label className="form-label">Perlu Periksa Lab?</label>
                                                                <Flex vertical gap="middle">
                                                                    <Radio.Group
                                                                        onChange={this.onChangeStatusSelesai}
                                                                        // defaultValue={0}
                                                                        buttonStyle="solid"
                                                                        value={this.state.peserta_statusSelesai}
                                                                    >
                                                                        <Radio.Button disabled={this.state.examSelected.REG_STATUS == "konsultasi" ? true : false} value={"PERIKSA LAB"}>{'Ya'}</Radio.Button>
                                                                        <Radio.Button value={"SELESAI"}>{'Tidak'}</Radio.Button>
                                                                    </Radio.Group>
                                                                </Flex>
                                                            </div>




                                                            <div className="form-group" style={{ display: this.state.peserta_statusSelesai == "SELESAI" ? 'none' : null }}>
                                                                <label className="form-label">Catatan Pemeriksaan Penunjang</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_catatanPemeriksaanPenunjang"
                                                                    value={this.state.peserta_catatanPemeriksaanPenunjang}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '120px' }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Pembayaran Konsultasi</label>
                                                                <Flex vertical gap="middle">
                                                                    <Radio.Group
                                                                        onChange={onChangePembayaranKonsultasi}
                                                                        // defaultValue={0}
                                                                        buttonStyle="solid"
                                                                        value={this.state.peserta_pembayaranKonsultasi}
                                                                    >
                                                                        <Radio.Button value={0}>{'Normal'}</Radio.Button>
                                                                        <Radio.Button value={1}>{'Free'}</Radio.Button>
                                                                        <Radio.Button value={2}>{'Diskon'}</Radio.Button>
                                                                        {/* <Radio.Button value={3}>{'Karyawan'}</Radio.Button> */}
                                                                    </Radio.Group>
                                                                </Flex>
                                                            </div>

                                                            {this.state.peserta_pembayaranKonsultasi == 1 ?

                                                                (

                                                                    <div className="form-group">
                                                                        <label className="form-label">Tipe Pasien</label>
                                                                        <Flex vertical gap="middle">
                                                                            <Radio.Group
                                                                                onChange={onChangeTipePasien}
                                                                                // defaultValue={0}
                                                                                buttonStyle="solid"
                                                                                value={this.state.peserta_tipePasien}
                                                                            >
                                                                                <Radio.Button value={0}>{'Non Karyawan'}</Radio.Button>
                                                                                <Radio.Button value={1}>{'Karyawan'}</Radio.Button>
                                                                            </Radio.Group>
                                                                        </Flex>
                                                                    </div>
                                                                )
                                                                :
                                                                null
                                                            }

                                                            {this.state.peserta_pembayaranKonsultasi == 2 ?

                                                                (

                                                                    <div className="form-group">
                                                                        <label className="form-label">Diskon (%)</label>
                                                                        <Flex vertical gap="middle">
                                                                            <Radio.Group
                                                                                onChange={onChangePembayaranDiskon}
                                                                                // defaultValue={0}
                                                                                buttonStyle="solid"
                                                                                value={this.state.peserta_pembayaranDiskon}
                                                                            >
                                                                                {/* <Radio.Button value={0}>{'Tidak Diskon'}</Radio.Button> */}
                                                                                <Radio.Button value={10}>{'10 %'}</Radio.Button>
                                                                                <Radio.Button value={20}>{'20 %'}</Radio.Button>
                                                                                <Radio.Button value={50}>{'50 %'}</Radio.Button>
                                                                            </Radio.Group>
                                                                        </Flex>
                                                                    </div>
                                                                )
                                                                :
                                                                null
                                                            }

                                                            {this.state.peserta_pembayaranKonsultasi == 2 ? (
                                                                <div className="form-group">
                                                                    <label className="form-label">Alasan Diskon</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="peserta_alasanDiskon"
                                                                        value={this.state.peserta_alasanDiskon}
                                                                        onChange={this.onChange}
                                                                    />
                                                                </div>

                                                            ) : null}


                                                            <div className="form-group">
                                                                <label className="form-label">Kontrol Ulang ?</label>
                                                                <Flex vertical gap="middle">
                                                                    <Radio.Group
                                                                        onChange={onChangeKontrolUlang}
                                                                        // defaultValue={0}
                                                                        buttonStyle="solid"
                                                                        value={this.state.peserta_kontrolUlang}
                                                                    >
                                                                        <Radio.Button value={0}>{'Tidak'}</Radio.Button>
                                                                        <Radio.Button value={1}>{'Iya'}</Radio.Button>
                                                                    </Radio.Group>
                                                                </Flex>
                                                            </div>

                                                        </div>
                                                        {/* <div className="col-md-6">

                                                        </div> */}
                                                    </div>
                                                </div>
                                            </form>
                                        </Tab.Pane>

                                        <Tab.Pane eventKey={3}>
                                            <form action="#" encType="multipart/form-data" id="form_add">
                                                <div className="form-content">
                                                    <div className="row">
                                                        <div className="col-md-12">

                                                            {/* <div className="form-group">
                                                                <label className="form-label">Catatan Resep</label>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="peserta_catatanResep"
                                                                    value={this.state.peserta_catatanResep}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '120px' }}
                                                                />
                                                            </div> */}




                                                            <div className="d-flex flex-column">
                                                                {/* <Editor
                                                                    editorStyle={{ border: "1px solid #7393B3", height: '200px' }}
                                                                    editorState={editorState}
                                                                    onEditorStateChange={this.onEditorStateChange}
                                                                />

                                                                <a
                                                                    href="#"
                                                                    id="lanjut"
                                                                    className="btn btn-info waves-effect"
                                                                    style={{ fontWeight: 'bold' }}
                                                                    onClick={() => this.copasP()}
                                                                >
                                                                    {" "}
                                                                    Copy Text From "P"
                                                                </a> */}


                                                                <form>
                                                                    {this.createUI()}
                                                                    {/* <input type='button' value='add more' onClick={this.addClick} /> */}

                                                                    <button
                                                                        className="btn btn-info btn-sm "
                                                                        style={{ backgroundColor: '#0f7051', backgroundImage: "url(" + plus + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                                                        type="button"
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                        title="add more"
                                                                        onClick={this.addClick}
                                                                    >
                                                                    </button>
                                                                </form>

                                                            </div>





                                                        </div>
                                                        {/* <div className="col-md-6"></div> */}
                                                    </div>
                                                </div>
                                            </form>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey={4}>
                                            <form action="#" encType="multipart/form-data" id="form_add">
                                                <div className="form-content">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label className="form-label" style={{ marginBottom: '-8px' }}>Jumlah Hari Sakit </label>
                                                                <span style={{ fontSize: 12, margin: 0, padding: 0, fontWeight: 'bold' }}>(isi jumlah hari sakit untuk membuat surat sakit)</span>
                                                                <div className="input-group mb-3">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        name="peserta_suratSakitHari"
                                                                        value={this.state.peserta_suratSakitHari}
                                                                        // defaultValue={0}
                                                                        onChange={this.onChange}
                                                                        onInput={this.suratSakitCheck}
                                                                    // maxLength="2"
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <span className="input-group-text"> Hari</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-md-6"></div> */}
                                                    </div>
                                                </div>
                                            </form>



                                        </Tab.Pane>

                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "0px solid #ffffff" }}>
                        <div style={{ display: this.state.formPerawat ? 'none' : null }}>
                            <Row>
                                {/* <Col
                                    style={{
                                        display: this.state.tabkey == 1 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="lanjut"
                                        className="btn btn-warning waves-effect"
                                        onClick={this.getLogExam.bind(this)}
                                        style={{ width: '80px', float: 'left' }}
                                    >
                                        <i className="fa fa-clock-o" />
                                        {" "}
                                        Log
                                    </a>
                                </Col> */}

                                <Col
                                    style={{
                                        display: this.state.tabkey == 1 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="lanjut"
                                        className="btn btn-info waves-effect"
                                        onClick={() => this.handleSelect(2)}
                                    >
                                        {" "}
                                        Next
                                    </a>
                                </Col>
                                <Col
                                    style={{
                                        display: this.state.tabkey == 1 || this.state.updateBtnV2 == true ? 'none' : null,
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.save_v2.bind(this)}
                                    >
                                        {" "}
                                        Save
                                    </a>

                                </Col>


                                <Col
                                    style={{
                                        display: this.state.tabkey == 2 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="lanjut"
                                        className="btn btn-info waves-effect"
                                        onClick={() => this.handleSelect(3)}
                                    >
                                        {" "}
                                        Next
                                    </a>
                                </Col>

                                <Col
                                    style={{
                                        display: this.state.tabkey == 3 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="lanjut"
                                        className="btn btn-info waves-effect"
                                        onClick={() => this.handleSelect(4)}
                                    >
                                        {" "}
                                        Next
                                    </a>
                                </Col>

                                <Col
                                    style={{
                                        display: this.state.tabkey == 4 && this.state.updateBtnV2 == true ? null : 'none',
                                        padding: 2,
                                    }}
                                >

                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_v2.bind(this)}
                                    >
                                        {" "}
                                        Update
                                    </a>
                                </Col>

                                <Col style={{ padding: 2 }}>
                                    <a
                                        href="#"
                                        id="btnCancelForm"
                                        className="btn btn-danger"
                                        onClick={this.handleCloseModalForm.bind(this)}
                                    >
                                        {" "}
                                        Cancel
                                    </a>
                                </Col>




                            </Row>
                        </div>

                        <div style={{ display: this.state.formPerawat ? null : 'none' }}>
                            <Row>
                                {/* <Col
                                    style={{
                                        display: this.state.tabkey == 1 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="lanjut"
                                        className="btn btn-warning waves-effect"
                                        onClick={this.getLogExam.bind(this)}
                                        style={{
                                            width: '80px',
                                            display: this.state.updateBtnV2 == true ? null : 'none',
                                        }}
                                    >
                                        <i className="fa fa-clock-o" />
                                        {" "}
                                        Log
                                    </a>
                                </Col> */}
                                <Col
                                    style={{
                                        display: this.state.updateBtnV2 == true ? 'none' : null,
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.save_v2.bind(this)}
                                    >
                                        {" "}
                                        Save
                                    </a>
                                </Col>

                                <Col
                                    style={{
                                        display: this.state.updateBtnV2 == true ? null : 'none',
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_v2.bind(this)}
                                        style={{}}
                                    >
                                        {" "}
                                        Update
                                    </a>
                                </Col>


                                <Col style={{ padding: 2 }}>
                                    <a
                                        href="#"
                                        id="btnCancelForm"
                                        className="btn btn-danger"
                                        onClick={this.handleCloseModalForm.bind(this)}
                                    >
                                        {" "}
                                        Cancel
                                    </a>
                                </Col>
                            </Row>
                        </div>

                        {/* <button
              type="button"
              className="close"
              onClick={this.handleCloseModalForm.bind(this)}
            >
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button> */}
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={this.state.modalFormResult}
                    onHide={this.handleCloseModalFormResult.bind(this)}
                    backdrop="static"
                    size="lg"
                    dialogClassName="custom-modal"
                    keyboard
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Input Result</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Tab.Container id="left-tabs-example" activeKey={this.state.tabkey}>
                            <Row>

                                <Col>
                                    <Tab.Content style={{ marginTop: 20 }}>
                                        <Tab.Pane eventKey={1} >
                                            <form action="#" method="post" encType="multipart/form-data" id="form_result">
                                                <div className="form-content">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="form-label">Nama Pasien</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_petugasInput"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.NAMA_PASIEN}
                                                                    readOnly={true}
                                                                />
                                                            </div>


                                                            <div className="form-group">
                                                                <label className="form-label">Date Result</label>
                                                                <input
                                                                    className="form-control"
                                                                    type="datetime-local"
                                                                    name="date_result"
                                                                    value={this.state.date_result}
                                                                    // value={moment(new Date(this.state.date_result)).format("YYYY-MM-DD hh:mm:ss")}
                                                                    onChange={this.onChange}
                                                                />

                                                            </div>


                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="form-label">Lab Result No.</label>
                                                                <input className="form-control" type="text" name="lab_result_no" value={this.state.lab_result_no} onChange={this.onChange} />

                                                            </div>



                                                            <div className="form-group">
                                                                <label className="form-label">Lab Result File (Jika Manual)</label>
                                                                <Dropzone onDrop={this.onDrop}>
                                                                    {({ getRootProps, getInputProps }) => (
                                                                        <section className="container">
                                                                            <div {...getRootProps({ className: 'dropzone' })}>
                                                                                <input {...getInputProps()} />
                                                                                <p>Drag 'n' drop some files here, or click to select files</p>
                                                                            </div>
                                                                            <aside style={{ textAlign: 'left' }}>
                                                                                {/* <p>Files</p> */}
                                                                                <ul>{files}</ul>
                                                                            </aside>
                                                                        </section>
                                                                    )}
                                                                </Dropzone>
                                                            </div>


                                                            {/* <div className="form-group">
                                                                <label className="form-label">Lab Result File (Jika Manual)</label>
                                                                <input className="form-control" type="file" name="lab_result_file" onChange={this.onFileChange} />

                                                            </div>
 */}





                                                        </div>
                                                    </div>
                                                </div>

                                            </form>
                                        </Tab.Pane>

                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "0px solid #ffffff" }}>
                        <div>
                            <Row>

                                <Col
                                    style={{
                                        // display: this.state.tabkey == 2 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >

                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_result.bind(this)}                                    >
                                        {" "}
                                        Save
                                    </a>
                                </Col>
                                <Col style={{ padding: 2 }}>
                                    <a
                                        href="#"
                                        id="btnCancelForm"
                                        className="btn btn-danger"
                                        onClick={this.handleCloseModalFormResult.bind(this)}
                                    >
                                        {" "}
                                        Cancel
                                    </a>
                                </Col>
                            </Row>
                        </div>
                    </Modal.Footer>
                </Modal>


                {/* <Modal
                    show={this.state.modalFormLab}
                    onHide={this.handleCloseModalFormLab.bind(this)}
                    backdrop="static"
                    dialogClassName="custom-modal"
                    keyboard
                    centered
                >
                    <Modal.Header closeButton>


                        <table >
                            <tbody>
                                <tr>
                                    <td> <p style={{ fontWeight: 'bold', margin: '0px' }}>REGISTRASI LAB</p></td>
                                </tr>
                                <tr>
                                    {
                                        localStorage.getItem("branch") ?
                                            (
                                                <td><span style={{ fontSize: 12 }}>{localStorage.getItem("name")} - {this.state.optBranch ? this.state.optBranch.find(el => el.value == localStorage.getItem("branch")).label : null}</span></td>
                                            ) :

                                            <></>
                                    }
                                </tr>
                            </tbody>
                        </table>

                    </Modal.Header>
                    <Modal.Body>
                        <Tab.Container id="left-tabs-example" activeKey={this.state.tabkey}>
                            <Row>
                                <Col md={12}>
                                    <Nav
                                        variant="pills"
                                    // defaultActiveKey="/home"
                                    // style={{ marginLeft: 8, marginRight: 8 }}
                                    >
                                        <Nav.Item>
                                            <Nav.Link
                                                eventKey={1}
                                                onClick={() => this.handleSelect(1)}
                                            // style={{ display: this.state.addPatientPeriode ? 'none' : null }}
                                            >
                                                Data Pasien
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                disabled
                                                eventKey={2}
                                                onClick={() => this.handleSelect(2)}
                                            >
                                                Tindak Lanjut
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col>
                                    <Tab.Content style={{ marginTop: 20 }}>
                                        <Tab.Pane eventKey={1} >
                                            <form action="#" encType="multipart/form-data" id="form_add">
                                                <div className="form-content">
                                                    <div className="row">
                                                        <div className="col-md-6">





                                                        </div>

                                                    </div>
                                                </div>

                                            </form>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey={2}>

                                            <form action="#" encType="multipart/form-data" id="form_add">
                                                <div className="form-content">
                                                    <div className="row">
                                                        <div className="col-md-12">

                                                        </div>

                                                    </div>
                                                </div>

                                            </form>



                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "0px solid #ffffff" }}>
                        <div>
                            <Row>
                                <Col
                                    style={{
                                        display: this.state.tabkey == 1 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="lanjut"
                                        className="btn btn-info waves-effect"
                                        onClick={() => this.handleSelect(2)}
                                    >
                                        {" "}
                                        Next
                                    </a>
                                </Col>
                                <Col
                                    style={{
                                        // display: this.state.tabkey == 2 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.save_v2.bind(this)}
                                        style={{ display: this.state.tabkey == 1 || this.state.updateBtnV2 == true ? 'none' : null }}
                                    >
                                        {" "}
                                        Save
                                    </a>

                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_v2.bind(this)}
                                        style={{ display: this.state.updateBtnV2 ? null : 'none' }}
                                    >
                                        {" "}
                                        Update
                                    </a>
                                </Col>
                                <Col style={{ padding: 2 }}>
                                    <a
                                        href="#"
                                        id="btnCancelForm"
                                        className="btn btn-danger"
                                        onClick={this.handleCloseModalFormLab.bind(this)}
                                    >
                                        {" "}
                                        cancel
                                    </a>
                                </Col>
                            </Row>
                        </div>


                    </Modal.Footer>
                </Modal> */}


                {/* modal kesimpulan */}
                <Modal
                    size="lg"
                // show={this.state.modalFormResult}
                // onHide={this.handleCloseModalFormResult.bind(this)}
                // backdrop="static"
                // dialogClassName="custom-modal"
                // keyboard
                // centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Input Result</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Tab.Container id="left-tabs-example" activeKey={this.state.tabkey}>
                            <Row>

                                <Col>

                                </Col>
                            </Row>
                        </Tab.Container>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "0px solid #ffffff" }}>
                        <div>
                            <Row>

                                <Col
                                    style={{
                                        // display: this.state.tabkey == 2 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >

                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_result.bind(this)}                                    >
                                        {" "}
                                        Save
                                    </a>
                                </Col>
                                <Col style={{ padding: 2 }}>
                                    <a
                                        href="#"
                                        id="btnCancelForm"
                                        className="btn btn-danger"
                                        onClick={this.handleCloseModalFormResult.bind(this)}
                                    >
                                        {" "}
                                        Cancel
                                    </a>
                                </Col>
                            </Row>
                        </div>
                    </Modal.Footer>
                </Modal>
                <Row>


                    <Col md={12} style={{ cursor: 'pointer' }}>
                        {tableInbox ? (
                            <PaginationProvider pagination={paginationFactory(options)}>
                                {contentTableInbox}
                            </PaginationProvider>
                        ) : null}
                    </Col>


                </Row>



            </>
        );
    }
}
export default withRouter(People)
